import { LOCALES } from "../constants";

const it = {
  [LOCALES.IT]: {
    //All page
    "Página não encontrada": "Pagina non trovata",
    //LOGIN PAGE
    "login.Login": "Accesso",
    "login.Informe seu e-mail": "Inserisci la tua e-mail",
    "login.E-mail inválido. Por favor, verifique":
    "E-mail non valida. Verifica e riprova",
    "login.Senha": "Password",
    "login.Sua senha deve possuir no mínimo 6 caracteres":
    "La password deve contenere almeno 6 caratteri",
    "login.Esqueci minha senha": "Ho dimenticato la password",
    "login.ENTRAR": "ACCEDI",
    "login.CRIAR CONTA": "CREA ACCOUNT",
    "login.Não foi possÍvel fazer o login. Verifique seus dados e tente novamente":
    "Impossibile effettuare l'accesso. Verifica i tuoi dati e riprova",
    "login.A PLATAFORMA IOK MUDOU!": "LA PIATTAFORMA IOK È CAMBIATA!",
    "login.Não exibir este aviso novamente": "Non mostrare più questo avviso",
    "login.Se você já possui um cadastro na antiga plataforma, ": "Se possiedi già un account sulla vecchia piattaforma, ",
    "login.clique aqui": "clicca qui",
    "login. para": " per ",
    "login.migrar": "migrare ",
    "login.seus dados e aproveitar toda a experiência IOK.": "i tuoi dati e usufruire di tutta l'esperienza IOK.",
    "login.Sua conta não foi ativada. Por gentileza, verifique seu e-mail para realizar a ativação": "Il tuo account non è stato attivato. Controlla la tua e-mail per completare l'attivazione",
    "login.PLATAFORMA EM MANUTENÇÃO": "PIATTAFORMA IN MANUTENZIONE",
    "login.ESTAMOS PREPARANDO A NOVA PLATAFORMA IOK E EM BREVE ELA ESTARÁ PRONTA!": "STIAMO PREPARANDO LA NUOVA PIATTAFORMA IOK E SARÀ PRESTO DISPONIBILE!",
    "login.Migrar Conta": "Migra account",
    "login.Se você já possui um cadastro na antiga plataforma, clique aqui em Migrar Conta para migrar seus dados e aproveitar toda a experiência IOK": "Se possiedi già un account sulla vecchia piattaforma, clicca su Migra account per trasferire i tuoi dati e usufruire di tutta l'esperienza IOK",
    "login.Política de privacidade": "Informativa sulla privacy",
    "login.ENTENDI": "HO CAPITO",
    "login.Para melhorar a sua experiência na plataforma e oferecer serviços personalizados, utilizamos cookies.": "Per migliorare la tua esperienza sulla piattaforma e offrire servizi personalizzati, utilizziamo i cookie.",
    "login.Ao utilizar a Plataforma IOK, você automaticamente concorda com seu uso.": "Utilizzando la Piattaforma IOK, accetti automaticamente il loro utilizzo.",
    "login.Senha incorreta! Duas tentativas restantes antes de ter o acesso à conta bloqueado.": "Password errata! Restano due tentativi prima che l'accesso all'account venga bloccato.",
    "login.Senha incorreta! Uma tentativa restantes antes de ter o acesso à conta bloqueado.": "Password errata! Resta un tentativo prima che l'accesso all'account venga bloccato.",
    "login.Acesso bloqueado! Siga as instruções de recuperação de conta.": "Accesso bloccato! Segui le istruzioni per il recupero dell'account.",
    
    // REGISTER
    "DISTRIBUIDOR": "DISTRIBUTORE:Sono un distributore di apparecchiature Prática.",
    "REDE": "RETE:Sono proprietario di una rete.",
    "DONO": "AZIENDA:Possiedo la mia azienda/faccio parte di una rete.",
    "register.Informe seu e-mail cadastrado na plataforma IOK anterior": "Inserisci l'e-mail registrata sulla precedente piattaforma IOK",
    "register.E-mail inválido. Por favor, verifique": "E-mail non valida. Verifica e riprova",
    "register.BUSCAR DADOS": "CERCA DATI",
    "register.Nome da organização": "Nome dell'organizzazione",
    "register.Informe o nome de sua organização": "Inserisci il nome della tua organizzazione",
    "register.O campo nome da organização é obrigatório": "Il campo nome dell'organizzazione è obbligatorio",
    "register.Este nome já existe. Por favor, escolha outro": "Questo nome esiste già. Scegline un altro",
    "register.RECUPERAR CONTA": "RECUPERA ACCOUNT",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA DE USUÁRIO. POR GENTILIZA, AGUARDE": "L'AMMINISTRATORE DELL'ORGANIZZAZIONE RICEVERÀ UN'E-MAIL PER ATTIVARE IL TUO ACCOUNT UTENTE. ATTENDI",
    "register.E-mail não encontrado": "E-mail non trovata",
    "register.Digite seu e-mail da plataforma IOK antiga": "Inserisci la tua e-mail della vecchia piattaforma IOK",
    "register.Não foi possível recuperar sua conta. Verifique seus dados e tente novamente": "Impossibile recuperare il tuo account. Verifica i dati e riprova",
    "register.Não foi possível recuperar seus dados. Verifique e tente novamente": "Impossibile recuperare i tuoi dati. Verifica e riprova",
    "register.PROSSEGUIR": "PROSEGUI",
    "register.VOCÊ ESTÁ SOLICITANDO ACESSO PARA A ORGANIZAÇÃO:": "STAI RICHIEDENDO L'ACCESSO ALL'ORGANIZZAZIONE:",
    "register.COM O ADMINISTRADOR:": " CON L'AMMINISTRATORE: ",
    "register.E-mail já cadastrado na plataforma. Informe um novo e-mail ou acesse a plataforma com o e-mail já cadastrado": "E-mail già registrata sulla piattaforma. Inserisci una nuova e-mail o accedi con quella già registrata",
    "register.Empresa já cadastrada na plataforma. Por favor, informe o nome de uma nova empresa": "Azienda già registrata sulla piattaforma. Inserisci il nome di una nuova azienda",
    "register.VOCÊ NÃO RECONHECEU O USUÁRIO {userName} COMO PARTE DA SUA ORGANIZAÇÃO E POR ISSO A CONTA DELE FOI DELETADA.": "NON HAI RICONOSCIUTO L'UTENTE {userName} COME PARTE DELLA TUA ORGANIZZAZIONE E PER QUESTO IL SUO ACCOUNT È STATO ELIMINATO.",
    "register.NÂO FOI POSSÍVEL DELETAR O USÁRIO {userName}. POR GENTILEZA, TENTE NOVAMENTE MAIS TARDE.": "NON È STATO POSSIBILE ELIMINARE L'UTENTE {userName}. RIPROVA PIÙ TARDI.",
    "register.CONFIRMAR": "CONFERMA",
    "register.Não foi possível fazer o cadastro. Verifique seus dados e tente novamente":
    "Impossibile completare la registrazione. Verifica i dati e riprova",
    "register.VOCÊ RECEBERÁ UM E-MAIL PARA CONCLUIR SEU CADASTRO E ATIVAR SUA CONTA DE ADMINISTRADOR":
    "RICEVERAI UN'E-MAIL PER COMPLETARE LA REGISTRAZIONE E ATTIVARE IL TUO ACCOUNT AMMINISTRATORE",
    "register.Nome": "Nome",
    "register.Informe seu nome": "Inserisci il tuo nome",
    "register.O campo nome é obrigatório": "Il campo nome è obbligatorio",
    "register.E-mail": "E-mail",
    "register.Informe seu e-mail": "Inserisci la tua e-mail",
    "register.E-mail inválido. Por favor, verifique novamente":
    "E-mail non valida. Verifica nuovamente",
    "register.Telefone": "Telefono",
    "register.Informe seu telefone": "Inserisci il tuo numero di telefono",
    "register.Crie sua senha": "Crea la tua password",
    "register.Informe sua senha": "Inserisci la tua password",
    "register.O campo senha deve conter no mínimo 6 caracteres":
    "La password deve contenere almeno 6 caratteri",
    "register.Confirme sua senha": "Conferma la tua password",
    "register.As senhas devem ser iguais": "Le password devono coincidere",
    "register.CRIAR CONTA": "CREA ACCOUNT",
    "register.CONTA ATIVADA COM SUCESSO": "ACCOUNT ATTIVATO CON SUCCESSO",
    "register.ACESSAR": "ACCEDI",
    "register.NÃO FOI POSSÍVEL ATIVAR SUA CONTA":
    "NON È STATO POSSIBILE ATTIVARE IL TUO ACCOUNT",
    "register.Digite seu telefone": "Inserisci il tuo numero di telefono",
    "register.AGUARDE ENQUANTO TRANSFERIMOS SEUS DADOS. ESTE PROCESSO DEVE LEVAR ALGUNS MINUTOS. CASO VOCÊ POSSUA UMA GRANDE QUANTIDADE DE DADOS, A TRANSFERÊNCIA PODE LEVAR ATÉ UMA HORA.": "ATTENDI MENTRE TRASFERIAMO I TUOI DATI. QUESTO PROCESSO RICHIEDE ALCUNI MINUTI. SE POSSIEDI UNA GRANDE QUANTITÀ DI DATI, IL TRASFERIMENTO POTREBBE RICHIEDERE FINO A UN'ORA.",
    "register.DADOS TRANSFERIDOS COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "DATI TRASFERITI CON SUCCESSO! CLICCA SUL PULSANTE QUI SOTTO PER ACCEDERE ALLA PIATTAFORMA.",
    "register.EMAIL INVÁLIDO. POR GENTILEZA, VERIFIQUE SE SUA CONTA JÁ FOI ATIVADA.": "E-MAIL NON VALIDA. VERIFICA SE IL TUO ACCOUNT È GIÀ STATO ATTIVATO.",
    "register.Ainda não tenho uma organização. Criar": "Non ho ancora un'organizzazione. Crea",
    "register.Informe o ID da organização": "Inserisci l'ID dell'organizzazione",
    "register.O campo com ID é obrigatório": "Il campo ID è obbligatorio",
    "register.O ADMINISTRADOR DA ORGANIZAÇÃO RECEBERÁ UM E-MAIL PARA ATIVAR SUA CONTA. POR GENTILIZA, AGUARDE": "L'AMMINISTRATORE DELL'ORGANIZZAZIONE RICEVERÀ UN'E-MAIL PER ATTIVARE IL TUO ACCOUNT. ATTENDI",
    "register.A nova plataforma IOK agora está dividida em organizações e possui diferentes tipos de conta, que ajudam a organizar melhor as grandes corporações, empresas e redes.": "La nuova piattaforma IOK è ora suddivisa in organizzazioni e dispone di diversi tipi di account che aiutano a gestire meglio grandi gruppi, aziende e reti.",
    "register.O administrador da minha organização já realizou a migração da conta e temos um ID. Desejo migrar meus dados de usuário.": "L'amministratore della mia organizzazione ha già effettuato la migrazione dell'account e disponiamo di un ID. Desidero migrare i miei dati utente.",
    "register.Desejo migrar a conta da minha organização e me tornar o administrador.": "Desidero migrare l'account della mia organizzazione e diventare amministratore.",
    "register.Conta da organização já migrada": "Account dell'organizzazione già migrato",
    "register.Migrar conta da organização": "Migra account dell'organizzazione",
    "register.A nova plataforma IOK agora conta com novas formas de acesso - que são referentes ao tipo de organização em que você atua. O responsável pela sua organização deve migrar a conta principal da empresa, se tornando o administrador, enquanto o restante dos funcionários devem se vincular a ela pelo ID fornecido.": "La nuova piattaforma IOK dispone ora di nuove modalità di accesso, legate al tipo di organizzazione a cui appartieni. Il responsabile dell'organizzazione deve migrare l'account principale dell'azienda diventando amministratore, mentre gli altri dipendenti devono collegarsi utilizzando l'ID fornito.",
    "register.ID informado não corresponde a nenhuma companhia. Verifique e tente novamente": "L'ID inserito non corrisponde a nessuna azienda. Verifica e riprova",
    "register.VOCÊ POSSUI MUITOS MENUS, NÃO CONSEGUIMOS REALIZAR A IMPORTAÇÃO AUTOMÁTICA. SUA CONTA SERÁ ATIVADA, PORÉM OS MENUS PRECISARÃO SER MIGRADOS MANUALMENTE.": "HAI TROPPI MENU. NON È STATO POSSIBILE ESEGUIRE L'IMPORTAZIONE AUTOMATICA. IL TUO ACCOUNT SARÀ ATTIVATO, MA I MENU DOVRANNO ESSERE MIGRATI MANUALMENTE.",
    "register.PARA MIGRAR SEUS MENUS, APÓS O LOGIN, CLIQUE NO SEU NOME NO CANTO SUPERIOR DIREITO, CLIQUE EM EDITAR CONTA E DEPOIS EM IMPORTAR MENUS.": "PER MIGRARE I TUOI MENU, DOPO L'ACCESSO CLICCA SUL TUO NOME IN ALTO A DESTRA, POI SU MODIFICA ACCOUNT E INFINE SU IMPORTA MENU.",
    "register.Atenção:": "Attenzione:",
    "register.apenas uma pessoa da organização pode criar a conta e, depois de ativá-la, convidar os demais usuários da empresa para acessá-la.": "solo una persona dell'organizzazione può creare l'account e, dopo averlo attivato, invitare gli altri utenti dell'azienda ad accedervi.",
    "register.TOKEN DESENVOLVEDOR CANCELADO": "TOKEN SVILUPPATORE ANNULLATO",
    "register.Sua senha deve estar entre 8 e 20 caracteres, ter uma letra maiúscula, uma minúscula, um número e um caractere especial": "La password deve contenere da 8 a 20 caratteri, una lettera maiuscola, una minuscola, un numero e un carattere speciale",
    
    //HOME
    "home.Menus disponíveis na plataforma": "Menu disponibili sulla piattaforma",
    "home.Criados na plataforma": "Creati sulla piattaforma",
    "home.Recebidos dos fornos": "Ricevuti dai forni",
    "home.Equipamentos vinculados": "Apparecchiature collegate",
    "home.Total de receitas cadastradas": "Totale ricette registrate",
    "home.Receitas": "Ricette",
    "home.Receitas em menus": "Ricette nei menu",
    "home.Em menus": "Nei menu",
    "home.Receitas salvas no Cookbook": "Ricette salvate nel Cookbook",
    "home.No Cookbook": "Nel Cookbook",
    "home.Atualizações": "Aggiornamenti",
    "home.Copa": "Copa",
    "home.Rocket": "Rocket",
    "home.Single Mag": "Single Mag",
    "home.Versão instalada": "Versione installata",
    "home.Versão disponível": "Versione disponibile",
    "home.Usuários cadastrados": "Utenti registrati",
    "home.Aceitação pendente": "Accettazione in sospeso",
    "home.Atualizado": "Aggiornato",
    "home.OLÁ": "CIAO",
    "home.É muito bom ter você aqui!": "È un piacere averti qui!",
    "home.Com a Plataforma IOK é possível administrar seus fornos de onde estiver, criar e gerenciar receitas e menus, fazer backups, analisar os dados de seus equipamentos e muito mais!": "Con la piattaforma IOK puoi gestire i tuoi forni ovunque ti trovi, creare e gestire ricette e menu, eseguire backup, analizzare i dati delle tue apparecchiature e molto altro!",
    "home.Conheça a plataforma": "Scopri la piattaforma",
    "home.Taxa de erro por modelo": "Tasso di errore per modello",
    "home.Erro": "Errore",
    "home.QUEREMOS SABER SUA OPINIÃO SOBRE": "VOGLIAMO CONOSCERE LA TUA OPINIONE SU",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a Plataforma {model} foi criado!": "Apprezziamo molto il tuo punto di vista e per questo abbiamo creato questo questionario di soddisfazione sulla piattaforma {model}!",
    "home.Valorizamos muito seu ponto de vista e, por isso, este formulário de pesquisa de satisfação sobre a linha {model} foi criado!": "Apprezziamo molto il tuo punto di vista e per questo abbiamo creato questo questionario di soddisfazione sulla linea {model}!",
    "home.Suas respostas nos ajudarão a aprimorar nossos serviços, garantindo que continuemos a oferecer a você a melhor experiência possível.": "Le tue risposte ci aiuteranno a migliorare i nostri servizi, garantendoti la migliore esperienza possibile.",
    "home.Reserve uns minutinhos de seu dia e participe!": "Dedica qualche minuto del tuo tempo e partecipa!",
    "home.Responder a pesquisa": "Rispondi al sondaggio",
    "home.Modelos em evidência": "Modelli in evidenza",
    "home.Modelos": "Modelli",
    "home.Total de equipamentos vinculados": "Totale apparecchiature collegate",
    "home.Total de equipamentos online": "Totale apparecchiature online",
    "home.Equipamentos online": "Apparecchiature online",
    "home.Países com Prática": "Paesi con Prática",
    "home.Países": "Paesi",
    "home.Aguarde enquanto carregamos os dados": "Attendi mentre carichiamo i dati",
    "home.Quase lá! Aguarde um pouco mais": "Ci siamo quasi! Attendi ancora un momento",
    "home.Vendas por Equipamento": "Vendite per apparecchiatura",
    "home.Total de equipamentos vendidos": "Totale apparecchiature vendute",
    "home.Equipamentos vendidos": "Apparecchiature vendute",
    "home.Clique para atualizar o software": "Clicca per aggiornare il software",
    "home.Aceitação de software pendente": "Accettazione aggiornamento software in sospeso",
    "home.Software atualizado": "Software aggiornato",
    "home.NENHUM EQUIPAMENTO VINCULADO": "NESSUNA APPARECCHIATURA COLLEGATA",
    "home.FORNOS LIGADOS": "FORNI ACCESI",
    "home.Enviando dados": "Invio dati",
    "home.Sem envio de dados": "Senza invio dati",
    "home.Criados na Plataforma": "Creati sulla piattaforma",
    "home.Apenas no Cookbook": "Solo nel Cookbook",
    "home.Usuários na companhia": "Utenti nell'azienda",
    "home.Inativos": "Inattivi",
    "home.Online": "Online",
    "home.Atualizações de equipamentos": "Aggiornamenti delle apparecchiature",
    "home.Modelos de equipamentos": "Modelli di apparecchiature",
    "home.Atualizados": "Aggiornati",
    "home.Aguardando Aceite": "In attesa di accettazione",
    "home.Desatualizados": "Non aggiornati",
    "home.Versão": "Versione",
    "home.Recente": "Recente",
    "home.Legenda": "Didascalia",
    "home.Chat": "Assistenza",
    
    //MAIN
    "main.HOME": "HOME",
    "main.COOKBOOK": "COOKBOOK",
    "main.MEUS MENUS": "I MIEI MENU",
    "main.EQUIPAMENTOS": "APPARECCHIATURE",
    "main.USUÁRIOS": "UTENTI",
    "main.ATENDIMENTOS": "ASSISTENZA",
    "main.Idioma": "Lingua",
    "main.Editar conta": "Modifica account",
    "main.Configurações": "Impostazioni",
    "main.Sair": "Esci",
    "main.Configurações salvas com sucesso!": "Impostazioni salvate con successo!",
    "main.SALVAR": "SALVA",
    "main.CONFIGURAÇÕES": "IMPOSTAZIONI",
    "main.Tema dark": "Tema scuro",
    "main.Notificações": "Notifiche",
    "main.Informações para as receitas": "Informazioni per le ricette",
    "main.Peso:": "Peso:",
    "main.Gramas": "Grammi",
    "main.Oz": "Oz",
    "main.Temperatura:": "Temperatura:",
    "main.Fahrenheit (°F)": "Fahrenheit (°F)",
    "main.Conta editada com sucesso!": "Account modificato con successo!",
    "main.EDITAR CONTA": "MODIFICA ACCOUNT",
    "main.Nome": "Nome",
    "main.Preencha com o seu nome": "Inserisci il tuo nome",
    "main.Telefone": "Telefono",
    "main.Preencha com o seu telefone": "Inserisci il tuo numero di telefono",
    "main.E-mail": "E-mail",
    "main.Preencha com o seu e-mail": "Inserisci il tuo indirizzo e-mail",
    "main.Alterar Senha": "Cambia password",
    "main.ALTERAR SENHA": "CAMBIA PASSWORD",
    "main.Senha atual": "Password attuale",
    "main.Nova senha": "Nuova password",
    "main.Confirmar nova senha": "Conferma nuova password",
    "main.Informe sua senha atual": "Inserisci la tua password attuale",
    "main.O campo senha deve conter no mínimo 6 caracteres": "Il campo password deve contenere almeno 6 caratteri",
    "main.Informe sua nova senha": "Inserisci la tua nuova password",
    "main.Confirme sua nova senha": "Conferma la tua nuova password",
    "main.Sua nova senha deve conter no mínimo 6 caracteres": "La nuova password deve contenere almeno 6 caratteri",
    "main.INFORME SUA SENHA": "INSERISCI LA TUA PASSWORD",
    "main.Informe sua senha para realizar a alteração de e-mail da plataforma:": "Inserisci la tua password per modificare l'e-mail della piattaforma:",
    "main.CONFIRMAR": "CONFERMA",
    "main.Existem campos que não foram preenchidos corretamente": "Alcuni campi non sono stati compilati correttamente",
    "main.Informe sua senha para prosseguir com a alteração de e-mail": "Inserisci la tua password per procedere con la modifica dell'e-mail",
    "main.Senha alterada com sucesso": "Password modificata con successo",
    "main.Informe sua senha atual corretamente": "Inserisci correttamente la tua password attuale",
    "main.As senhas devem ser iguais": "Le password devono essere uguali",
    "main.Nome do novo tipo de usuário": "Nome del nuovo tipo di utente",
    "main.Dê um nome para o novo tipo de usuário": "Assegna un nome al nuovo tipo di utente",
    "main.Token Desenvolvedor": "Token sviluppatore",
    "main.O Token Desenvolvedor é um código único e intransferível que permite a realização de alterações": "Il Token Sviluppatore è un codice univoco e non trasferibile che consente di apportare modifiche a livello di sviluppo direttamente al codice della piattaforma tramite API esterne. Queste permettono di personalizzare la piattaforma per soddisfare meglio le esigenze della tua azienda.",
    "main.É recomendado que estas alterações sejam realizadas por um profissional da área de tecnologia": "Si consiglia che queste modifiche siano effettuate da un professionista del settore tecnologico.",
    "main.Para acessar o token, informe sua senha": "Per accedere al token, inserisci la tua password",
    "main.Copie e cole o token na autenticação de todas as requisições.": "Copia e incolla il token nell'autenticazione di tutte le richieste.",
    "main.Seu Token": "Il tuo token",
    "main.Token copiado com sucesso!": "Token copiato con successo!",
    "main.Você deseja cancelar o preenchimento das informações?": "Vuoi annullare la compilazione delle informazioni?",
    "main.Rever tutoriais": "Rivedi i tutorial",
    "main.Tutoriais resetados com sucesso!": "Tutorial reimpostati con successo!",
    "main.review.tutorials": "Vuoi rivedere i tutorial della piattaforma IOK?",
    "main.Procurar": "Cerca",
    "main.review.manual": "È anche possibile salvarlo sul proprio computer.",
    "main.review.download": "Accedi al manuale",
    
    //MEUS MENUS
    "menus.Procurar menu": "Cerca menu o utente",
    "menus.Procurar menu excluído": "Cerca menu eliminato",
    "menus.Menus": "Menu",
    "menus.Lixeira": "Cestino",
    "menus.CRIAR MENU": "CREA MENU",
    "menus.IMPORTAR MENU": "IMPORTA MENU",
    "menus.Os arquivos serão mantidos na lixeira por 30 dias a contar de sua data de exclusão. Após este período, eles serão excluídos definitivamente.": "I file saranno conservati nel Cestino per 30 giorni dalla data di eliminazione. Dopo questo periodo, saranno eliminati definitivamente.",
    "menus.VOLTAR": "indietro",
    "menus.Compatível com: ": "Compatibile con: ",
    "menus.Última atualização: ": "Ultimo aggiornamento: ",
    "menus.EXPORTAR MENU": "ESPORTA MENU",
    "menus.EDITAR MENU": "MODIFICA MENU",
    "menus.Equipamentos associados": "Apparecchiature associate",
    "menus.Grupos": "Gruppi",
    "menus.Procurar grupo": "Cerca gruppo",
    "menus.CRIAR GRUPO": "CREA GRUPPO",
    "menus.receitas": "ricette",
    "menus.Nenhum grupo cadastrado": "Nessun gruppo registrato",
    "menus.Nenhum menu cadastrado": "Nessun menu registrato",
    "menus.Nome": "Nome",
    "menus.Modelo": "Modello",
    "menus.Atividade": "Attività",
    "menus.Associação": "Associazione",
    "menus.Exportar": "Esporta",
    "menus.Editar": "Modifica",
    "menus.Excluir": "Elimina",
    "menus.Equips": "App.",
    "menus.Receitas": "Ricette",
    "menus.Compatibilidade": "Compatibilità",
    "menus.Última atualização": "Ultimo aggiornamento",
    "menus.Versão": "Versione",
    "menus.Origem": "Origine",
    "menus.Excluído por": "Eliminato da",
    "menus.Data de exclusão": "Data di eliminazione",
    "menus.Restaurar": "Ripristina",
    "menus.Existem campos que não foram preenchidos": "Ci sono campi non compilati",
    "menus.Menu criado com sucesso!": "Menu creato con successo!",
    "menus.Existem campos com informações inválidas": "Ci sono campi con informazioni non valide",
    "menus.SALVAR": "SALVA",
    "menus.CANCELAR": "ANNULLA",
    "menus.Nome do menu": "Nome del menu",
    "menus.Informe o nome do menu": "Inserisci il nome del menu",
    "menus.Preencha o nome do menu sem caracteres especiais": "Inserisci il nome del menu senza caratteri speciali",
    "menus.Apenas os caracteres @#%&*-+()!\"<>:;\\/?. são permitidos": "Sono consentiti solo i caratteri @#%&*-+()!\"<>:;\\/?.",
    "menus.Selecionar": "Seleziona",
    "menus.Idioma": "Lingua",
    "menus.Temperatura de pré-aquec 1": "Temperatura di preriscaldamento 1",
    "menus.Informe a temperatura de pré-aquec 1": "Inserisci la temperatura di preriscaldamento 1",
    "menus.Temperatura de pré-aquec 2": "Temperatura di preriscaldamento 2",
    "menus.Informe a temperatura de pré-aquec 2": "Inserisci la temperatura di preriscaldamento 2",
    "menus.Tempo para estabilização": "Tempo di stabilizzazione",
    "menus.Informe o tempo para estabilização": "Inserisci il tempo di stabilizzazione",
    "menus.Desativar pré-aquec 2": "Disattiva preriscaldamento 2",
    "menus.Configurações de data e hora": "Impostazioni di data e ora",
    "menus.Data:": "Data:",
    "menus.DD/MM/AAAA": "GG/MM/AAAA",
    "menus.Hora:": "Ora:",
    "menus.24h": "24h",
    "menus.AM/PM": "AM/PM",
    "menus.EUR: DD/MM/AAAA": "EUR: GG/MM/AAAA",
    "menus.USA: MM/DD/AAAA": "USA: MM/GG/AAAA",
    "menus.ISO: AAAA/MM/DD": "ISO: AAAA/MM/GG",
    "menus.Seleção de acessos para habilitar": "Selezione degli accessi da abilitare",
    "menus.Modo manual": "Modalità manuale",
    "menus.Habilitado": "Abilitato",
    "menus.Desabilitado": "Disabilitato",
    "menus.Favoritos": "Preferiti",
    "menus.Aquecer/Dourar": "Riscaldare/Dorare",
    "menus.Repetir receita": "Ripeti ricetta",
    "menus.Configurações gerais do menu": "Impostazioni generali del menu",
    "menus.Temperatura:": "Temperatura:",
    "menus.Fahrenheit (°F)": "Fahrenheit (°F)",
    "menus.Gramas": "Grammi",
    "menus.Oz": "Oz",
    "menus.Tema:": "Tema:",
    "menus.Dark": "Scuro",
    "menus.Light": "Chiaro",
    "menus.Introdução:": "Introduzione:",
    "menus.Ativada": "Attivata",
    "menus.Desativada": "Disattivata",
    "menus.Menu deletado com sucesso!": "Menu eliminato con successo!",
    "menus.Não foi possivel deletar o menu": "Impossibile eliminare il menu",
    "menus.Sim": "Sì",
    "menus.Não": "No",
    "menus.Excluir definitivamente": "Elimina definitivamente",
    "menus.SALVAR NO DISPOSITIVO": "SALVA SUL DISPOSITIVO",
    "menus.EXPORTAR": "ESPORTA",
    "menus.Selecione os modelos e versões dos equipamentos que receberão o menu.": "Seleziona i modelli e le versioni delle apparecchiature che riceveranno il menu.",
    "menus.Forno": "Forno",
    "menus.Fundo verde": "Sfondo verde",
    "menus.Fundo preto": "Sfondo nero",
    "menus.Linux": "Linux",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, exceto para menus de equipamentos Linux.": "Attenzione: prima di trasferire il menu dalla chiavetta USB all'apparecchiatura, è necessario estrarre il file, ad eccezione dei menu per apparecchiature Linux.",
    "menus.Selecione os equipamentos para os quais deseja exportar o menu.": "Seleziona le apparecchiature per le quali desideri esportare il menu.",
    "menus.Nome do equipamento": "Nome dell'apparecchiatura",
    "menus.Selecionar todos": "Seleziona tutti",
    "menus.Selecionar todas": "Seleziona tutte",
    "menus.Categoria: ": "Categoria: ",
    "menus.Você deseja excluir o menu?": "Desideri eliminare il menu?",
    "menus.O menu será deletado da plataforma, mas permanecerá no equipamento. Uma cópia de segurança será criada automaticamente e ficará disponível por 30 dias em Meus Menus - Lixeira.": "Il menu verrà eliminato dalla piattaforma, ma rimarrà sull'apparecchiatura. Una copia di backup verrà creata automaticamente e sarà disponibile per 30 giorni in I miei menu - Cestino.",
    "menus.Você deseja excluir o arquivo definitivamente?": "Desideri eliminare definitivamente il file?",
    "menus.Esta ação não poderá ser desfeita.": "Questa azione non può essere annullata.",
    "menus.Menu editado com sucesso!": "Menu modificato con successo!",
    "menus.IMPORTAR": "IMPORTA",
    "menus.VERIFICAÇÃO DE VERSÃO": "VERIFICA DELLA VERSIONE",
    "menus.Para conferir a versão da placa de seu equipamento, siga os seguintes passos:": "Per verificare la versione della scheda della tua apparecchiatura, segui i passaggi seguenti:",
    "menus.No forno, acesse Configurações;": "Sul forno, accedi a Impostazioni;",
    "menus.Insira a senha 456789;": "Inserisci la password 456789;",
    "menus.Selecione a opção Sistema;": "Seleziona l'opzione Sistema;",
    "menus.Selecione Informações do Fabricante;": "Seleziona Informazioni del produttore;",
    "menus.O modelo de sua placa estará na linha Firmware IHM;": "Il modello della tua scheda sarà indicato nella riga Firmware IHM;",
    "menus.1ª geração A": "1ª generazione A",
    "menus.Firmware IHM: 12.3.4": "Firmware IHM: 12.3.4",
    "menus.1ª geração B": "1ª generazione B",
    "menus.2ª geração/Linux:": "2ª generazione/Linux:",
    "menus.Firmware IHM: L1.2.3": "Firmware IHM: L1.2.3",
    "menus.Selecione o modelo/versão do equipamento do qual deseja importar o menu. Saiba como conferir a versão de seu equipamento": "Seleziona il modello/versione dell'apparecchiatura da cui desideri importare il menu. Scopri come verificare la versione della tua apparecchiatura",
    "menus.Como verificar a versão da placa": "Come verificare la versione della scheda",
    "menus.1° Geração": "1ª Generazione",
    "menus.Menu restaurado com sucesso!": "Menu ripristinato con successo!",
    "menus.Não foi possivel restaurar o menu": "Impossibile ripristinare il menu",
    "menus.RESTAURAR ARQUIVO": "RIPRISTINA FILE",
    "menus.Você deseja restaurar o arquivo?": "Desideri ripristinare il file?",
    "menus.O arquivo será restaurado como uma nova versão na plataforma, na guia Todos. Para salvá-lo no equipamento, exporte-o.": "Il file verrà ripristinato come una nuova versione sulla piattaforma, nella scheda Tutti. Per salvarlo sull'apparecchiatura, esportalo.",
    "menus.EXCLUIR MENU": "ELIMINA MENU",
    "menus.Nenhum equipamento associado": "Nessuna apparecchiatura associata",
    "menus.Nomeie o novo menu": "Assegna un nome al nuovo menu",
    "menus.Nomeie o novo grupo": "Assegna un nome al nuovo gruppo",
    "menus.Nome do grupo": "Nome del gruppo",
    "menus.Preencha o nome do grupo sem caracteres especiais": "Inserisci il nome del gruppo senza caratteri speciali",
    "menus.Pré-aquecimento:": "Preriscaldamento:",
    "menus.Grupo criado com sucesso!": "Gruppo creato con successo!",
    "menus.SELECIONE UMA IMAGEM": "SELEZIONA UN'IMMAGINE",
    "menus.SELECIONAR": "SELEZIONA",
    "menus.Selecionar do dispositivo": "Seleziona dal dispositivo",
    "menus.Selecionar do banco de imagens": "Seleziona dalla banca immagini",
    "menus.Formato .JPG ou .PNG": "Formato .JPG o .PNG",
    "menus.Procurar imagem": "Cerca immagine",
    "menus.Pertence ao menu": "Appartiene al menu",
    "menus.Alterar imagem": "Modifica immagine",
    "menus.Remover imagem": "Rimuovi immagine",
    "menus.EDITAR GRUPO": "MODIFICA GRUPPO",
    "menus.Nome:": "Nome:",
    "menus.CRIAR RECEITA": "CREA RICETTA",
    "menus.SALVAR DO COOKBOOK": "SALVA DAL COOKBOOK",
    "menus.Procurar receita do grupo": "Cerca ricetta del gruppo",
    "menus.Ingrediente principal": "Ingrediente principale",
    "menus.Limpar filtros": "Cancella filtri",
    "menus.Filtrar": "Filtra",
    "menus.Mover receitas": "Sposta ricette",
    "menus.Excluir receitas": "Elimina ricette",
    "menus.Editar grupo": "Modifica gruppo",
    "menus.Excluir grupo": "Elimina gruppo",
    "menus.aqui": "qui",
    "menus.Se o código possuir apenas números e o fundo da tela for verde, pertence à 1ª A, se possuir apenas números e o fundo da tela for preta, pertence à 1ª B e, se começar com as letras L, F ou S, sua placa pertence à 2ª geração/Linux.": "Se il codice contiene solo numeri e lo sfondo dello schermo è verde, appartiene alla 1ª A; se contiene solo numeri e lo sfondo è nero, appartiene alla 1ª B; se inizia con le lettere L, F o S, la scheda appartiene alla 2ª generazione/Linux.",
    "menus.1ª A - Fundo verde": "1ª A - Sfondo verde",
    "menus.1ª B - Fundo preto": "1ª B - Sfondo nero",
    "menus.2ª - Linux": "2ª - Linux",
    "menus.Tivemos um problema. Tente novamente mais tarde.": "Si è verificato un problema. Riprova più tardi.",
    "menus.Grupo editado com sucesso!": "Gruppo modificato con successo!",
    "menus.AINDA NÃO HÁ GRUPOS AQUI :(": "NON CI SONO ANCORA GRUPPI QUI :(",
    "menus.description.AINDA NÃO HÁ GRUPOS AQUI :(": "Fai clic sul pulsante nell'angolo in alto a destra e aggiungi dei gruppi.",
    "menus.NENHUM MENU NA LIXEIRA": "NESSUN MENU NEL CESTINO",
    "menus.AINDA NÃO HÁ MENUS AQUI :(": "NON CI SONO ANCORA MENU QUI :(",
    "menus.description.AINDA NÃO HÁ MENUS AQUI :(": "Fai clic su uno dei pulsanti nell'angolo in alto a destra e aggiungi dei menu.",
    "menus.Adicionar imagem": "Aggiungi immagine",
    "menus.Nome da receita": "Nome della ricetta",
    "menus.Detalhes da receita": "Dettagli della ricetta",
    "menus.Programação da receita": "Programmazione della ricetta",
    "menus.Nomeie sua receita": "Assegna un nome alla tua ricetta",
    "menus.Preencha o nome da receita sem caracteres especiais": "Inserisci il nome della ricetta senza caratteri speciali",
    "menus.Tipo de prato": "Tipo di piatto",
    "menus.SALVAR RECEITAS DO COOKBOOK": "SALVA RICETTE DAL COOKBOOK",
    "menus.Selecione as receitas que deseja salvar no grupo de seu menu:": "Seleziona le ricette che desideri salvare nel gruppo del tuo menu:",
    "menus.Procurar receita": "Cerca ricetta",
    "menus.deleteGroupSuccess": "{count, plural, one {Gruppo eliminato con successo!} other {Gruppi eliminati con successo!}}",
    "menus.deleteGroupError": "{count, plural, one {Impossibile eliminare il gruppo.} other {Impossibile eliminare i gruppi.}}",
    "menus.EXCLUIR GRUPO": "ELIMINA GRUPPO",
    "menus.confirmDeleteGroupMessage": "{count, plural, one {Desideri eliminare definitivamente il gruppo?} other {Desideri eliminare definitivamente i gruppi?}}",
    "menus.AINDA NÃO HÁ RECEITAS AQUI :(": "NON CI SONO ANCORA RICETTE QUI :(",
    "menus.description.AINDA NÃO HÁ RECEITAS AQUI :(": "Fai clic su uno dei pulsanti nell'angolo in alto a destra e aggiungi delle ricette.",
    "menus.Temp. de entrada": "Temp. di ingresso",
    "menus.Temp. de pré-aquec": "Temp. di preriscaldamento",
    "menus.Ingredientes para montagem": "Ingredienti per l'assemblaggio",
    "menus.Instruções operacionais": "Istruzioni operative",
    "menus.Passo": "Passo",
    "menus.Temp": "Temp",
    "menus.Temp.": "Temp.",
    "menus.Tempo": "Tempo",
    "menus.Velocidade do ar": "Velocità dell'aria",
    "menus.Micro-ondas": "Microonde",
    "menus.Resistência inferior": "Resistenza inferiore",
    "menus.Informações": "Informazioni",
    "menus.Digite as informações do passo": "Inserisci le informazioni del passaggio",
    "menus.desativar": "disattiva",
    "menus.Ingredientes": "Ingredienti",
    "menus.Temperatura de entrada": "Temperatura di ingresso",
    "menus.Equipamentos compatíveis": "Apparecchiature compatibili",
    "menus.Tempo total": "Tempo totale",
    "menus.SALVAR NO COOKBOOK": "SALVA NEL COOKBOOK",
    "menus.ver localização": "visualizza posizione",
    "menus.SELECIONE RECEITAS PARA EXCLUIR": "SELEZIONA LE RICETTE DA ELIMINARE",
    "menus.Você deseja excluir as receitas selecionadas definitivamente?": "Desideri eliminare definitivamente le ricette selezionate?",
    "menus.Receitas deletadas com sucesso!": "Ricette eliminate con successo!",
    "menus.Informe aqui os ingredientes para montagem": "Inserisci qui gli ingredienti per l'assemblaggio",
    "menus.Informe aqui as instruções operacionais": "Inserisci qui le istruzioni operative",
    "menus.Adicionar passo": "Aggiungi passo",
    "menus.Receita criada com sucesso!": "Ricetta creata con successo!",
    "menus.Ideal para:": "Ideale per:",
    "menus.editar detalhes": "modifica dettagli",
    "menus.excluir": "elimina",
    "menus.editar": "modifica",
    "menus.Receita editada com sucesso!": "Ricetta modificata con successo!",
    "menus.Passo deletado com sucesso!": "Passo eliminato con successo!",
    "menus.Não foi possivel deletar o passo": "Impossibile eliminare il passo",
    "menus.EXCLUIR PASSO": "ELIMINA PASSO",
    "menus.Você deseja excluir este passo?": "Desideri eliminare questo passaggio?",
    "menus.Esta ação não poderá ser desfeita. Caso prefira, é possível apenas desativá-lo, mantendo assim sua configuração.": "Questa azione non può essere annullata. Se preferisci, puoi semplicemente disattivarlo mantenendo la sua configurazione.",
    "menus.Peso": "Peso",
    "menus.Origem da receita": "Origine della ricetta",
    "menus.Pré-aquecimento": "Preriscaldamento",
    "menus.Plataforma": "Piattaforma",
    "menus.Receita salva com sucesso!": "Ricetta salvata con successo!",
    "menus.Exportar receitas": "Esporta ricette",
    "menus.expandir": "espandi",
    "menus.Temperatura": "Temperatura",
    "menus.Vapor combinado": "Vapore combinato",
    "menus.Ar quente": "Aria calda",
    "menus.Sonda": "Sonda",
    "menus.Tempo (min)": "Tempo (min)",
    "menus.Umidade (%)": "Umidità (%)",
    "menus.Injeção de vapor": "Iniezione di vapore",
    "menus.Dumper aberto": "Dumper aperto",
    "menus.Informe o peso": "Inserisci il peso",
    "menus.Informe a temperatura de entrada": "Inserisci la temperatura di ingresso",
    "menus.Informe os ingredientes para montagem": "Inserisci gli ingredienti per l'assemblaggio",
    "menus.Informe as instruções operacionais": "Inserisci le istruzioni operative",
    "menus.Injeção de vapor (seg)": "Iniezione di vapore (sec)",
    "menus.Aquecer mais": "Riscaldare di più",
    "menus.Dourar mais": "Dorare di più",
    "menus.Aquecer e dourar mais": "Riscaldare e dorare di più",
    "menus.Favoritar receita": "Aggiungi la ricetta ai preferiti",
    "menus.Informe o tempo para aquecer mais": "Inserisci il tempo per riscaldare di più",
    "menus.Informe o tempo para dourar mais": "Inserisci il tempo per dorare di più",
    "menus.Informe o tempo para aquecer e dourar mais": "Inserisci il tempo per riscaldare e dorare di più",
    "menus.Apenas favoritos": "Solo preferiti",
    "menus.Forno combinado": "Forno combinato",
    "menus.Cocção múltipla": "Cottura multipla",
    "menus.Receitas Technicook": "Ricette Technicook",
    "menus.Editar grupos": "Modifica gruppi",
    "menus.Informe a data": "Inserisci la data",
    "menus.Informe a hora": "Inserisci l'ora",
    "menus.até 300": "fino a 300",
    "menus.Vapor": "Vapore",
    "menus.Turbina": "Ventola",
    "menus.Criar grupo": "Crea gruppo",
    "menus.MOVER": "SPOSTA",
    "menus.Configurações de data e hora:": "Impostazioni di data e ora:",
    "menus.Configurações de acessos:": "Impostazioni degli accessi:",
    "menus.Modo manual:": "Modalità manuale:",
    "menus.Favoritos:": "Preferiti:",
    "menus.Aquecer/dourar:": "Riscaldare/dorare:",
    "menus.Repetir receita:": "Ripeti ricetta:",
    "menus.Configurações gerais do menu:": "Impostazioni generali del menu:",
    "menus.SELECIONE RECEITAS PARA MOVER": "SELEZIONA LE RICETTE DA SPOSTARE",
    "menus.AVANÇAR": "AVANTI",
    "menus.Selecione ou crie um grupo no mesmo menu para mover as receitas selecionadas ou as mova para outro menu. Note que apenas os menus/grupos compatíveis com as predefinições das receitas serão exibidos.": "Seleziona o crea un gruppo nello stesso menu per spostare le ricette selezionate oppure spostale in un altro menu. Nota che verranno visualizzati solo i menu/gruppi compatibili con le impostazioni predefinite delle ricette.",
    "menus.Mover receitas para o mesmo menu": "Sposta le ricette nello stesso menu",
    "menus.Mover receitas para outro menu": "Sposta le ricette in un altro menu",
    "menus.Selecionar grupo": "Seleziona gruppo",
    "menus.Nenhuma receita foi selecionada": "Nessuna ricetta selezionata",
    "menus.Passo editado com sucesso!": "Passaggio modificato con successo!",
    "menus.Menu atualizado": "Menu aggiornato",
    "menus.até 260": "fino a 260",
    "menus.Umidade na câmara": "Umidità nella camera",
    "menus.Passos": "Passaggi",
    "menus.ativar": "attiva",
    "menus.Informe a temperatura de pré-aquec": "Inserisci la temperatura di preriscaldamento",
    "menus.Movas as receitas selecionadas para outro menu. Note que apenas os menus compatíveis com as predefinições das receitas serão exibidos.": "Sposta le ricette selezionate in un altro menu. Nota che verranno visualizzati solo i menu compatibili con le impostazioni predefinite delle ricette.",
    "menus.Sonda (°C)": "Sonda (°C)",
    "menus.Turbo Grill": "Turbo Grill",
    "menus.Pré-aquecimento padrão, conforme passo 1": "Preriscaldamento predefinito, come nel passaggio 1",
    "menus.salvar": "salva",
    "menus.até": "fino a",
    "menus.Verificação de receita": "Verifica della ricetta",
    "menus.Auto import": "Importazione automatica",
    "menus.Atualização forçada": "Aggiornamento forzato",
    "menus.Lista de receitas exportada com sucesso!": "Elenco delle ricette esportato con successo!",
    "menus.Receita movida com sucesso!": "Ricetta spostata con successo!",
    "menus.Receitas movidas com sucesso!": "Ricette spostate con successo!",
    "menus.+ Menu": "+ Menu",
    "menus.+ Receita": "+ Ricetta",
    "menus.Selecione o modelo/versão do equipamento": "Seleziona il modello/versione dell'apparecchiatura",
    "menus.Escolha um idioma compatível com o equipamento": "Scegli una lingua compatibile con l'apparecchiatura",
    "menus.MENU IMPORTADO COM SUCESSO!": "MENU IMPORTATO CON SUCCESSO!",
    "menus.Dourar": "Dorare",
    "menus.Não atribuir a menu": "Non assegnare a un menu",
    "menus.Todos": "Tutti",
    "menus.Meus menus": "I miei menu",
    "menus.Para salvar uma receita, preencha todos os campos": "Per salvare una ricetta, compila tutti i campi",
    "menus.Selecione os grupos de equipamentos para os quais deseja exportar o menu.": "Seleziona i gruppi di apparecchiature per i quali desideri esportare il menu.",
    "menus.Formato inválido. São permitidos apenas os formatos .jpeg e .png": "Formato non valido. Sono consentiti solo i formati .jpeg e .png",
    "menus.Reordenar grupos": "Riordina gruppi",
    "menus.O que deseja fazer?": "Cosa desideri fare?",
    "menus.Reordenar receitas": "Riordina ricette",
    "menus.ITENS REORDENADOS COM SUCESSO! PARA APLICAR AS ALTERAÇÕES NO FORNO, EXPORTE O MENU.": "ELEMENTI RIORDINATI CON SUCCESSO! PER APPLICARE LE MODIFICHE AL FORNO, ESPORTA IL MENU.",
    "menus.ARRASTE OS ITENS PARA O LOCAL DESEJADO": "TRASCINA GLI ELEMENTI NELLA POSIZIONE DESIDERATA",
    "menus.Dumper": "Dumper",
    "menus.Aberto": "Aperto",
    "menus.Fechado": "Chiuso",
    "menus.Intermitente": "Intermittente",
    "menus.Se o seu menu incluir itens sensíveis à uniformidade, recomendamos definir o Tempo de Estabilização entre 3:00 e 5:00 minutos. Caso contrário, você pode deixá-lo em 5 segundos.": "Se il tuo menu include elementi sensibili all'uniformità, consigliamo di impostare il Tempo di Stabilizzazione tra 3:00 e 5:00 minuti. In caso contrario, puoi lasciarlo a 5 secondi.",
    "menus.Selecione o menu que deseja exportar:": "Seleziona il menu che desideri esportare:",
    "menus.Temperatura de pré-aquecimento": "Temperatura di preriscaldamento",
    "menus.Temperatura de lastro": "Temperatura della piastra",
    "menus.Temperatura de teto": "Temperatura superiore",
    "menus.Volume de injeção de vapor (ml)": "Volume di iniezione del vapore (ml)",
    "menus.Parada de turbina": "Arresto della ventola",
    "menus.Alta": "Alta",
    "menus.Média": "Media",
    "menus.Baixa": "Bassa",
    "menus.a": "a",
    "menus.Valor da injeção": "Valore dell'iniezione",
    "menus.Volume: até 999ml": "Volume: fino a 999 ml",
    "menus.Tempo: até 15 segundos": "Tempo: fino a 15 secondi",
    "menus.Tempo de injeção de vapor (seg)": "Tempo di iniezione del vapore (sec)",
    "menus.Atenção!": "Attenzione!",
    "menus.Verifique as receitas do menu e ajuste os valores da Injeção de Vapor após alterar sua unidade de medida.": "Verifica le ricette del menu e regola i valori dell'Iniezione di Vapore dopo aver modificato la relativa unità di misura.",
    "menus.Certifique-se de que a unidade de temperatura (°C ou °F) definida no equipamento seja a mesma que foi selecionada na criação do menu:": "Assicurati che l'unità di temperatura (°C o °F) impostata sull'apparecchiatura sia la stessa selezionata durante la creazione del menu:",
    "menus.Injeção desativada": "Iniezione disattivata",
    "menus.Selecione a unidade de temperatura que está definida no equipamento:": "Seleziona l'unità di temperatura impostata sull'apparecchiatura:",
    "menus.Clique para atualizar": "Clicca per aggiornare",
    "menus.A função Atualização Forçada envia automaticamente o menu para os equipamentos selecionados, e que possuam versão compatível com este tipo de atualização, na próxima vez em que forem ligados. Os fornos que não estiverem atualizados ainda precisarão realizar o aceite manual.": "La funzione Aggiornamento Forzato invia automaticamente il menu alle apparecchiature selezionate che dispongono di una versione compatibile con questo tipo di aggiornamento, la prossima volta che verranno accese. I forni non aggiornati dovranno comunque accettare manualmente l'aggiornamento.",
    "menus.As opções selecionadas estarão disponíveis nos equipamentos que receberem este menu, podendo ser utilizadas pelo operador. É possível alterar estas configurações posteriormente no próprio forno ou pela plataforma.": "Le opzioni selezionate saranno disponibili sulle apparecchiature che riceveranno questo menu e potranno essere utilizzate dall'operatore. È possibile modificare queste impostazioni successivamente direttamente dal forno o dalla piattaforma.",
    "menus.Não foi possivel deletar as receitas": "Impossibile eliminare le ricette",
    "menus.PRÉ": "PRE",
    "menus.Speed Ovens": "Speed Ovens",
    "menus.Fornos Combinados": "Forni combinati",
    "menus.Fornos de Panificação": "Forni da panificazione",
    "menus.Após a criação, o tipo do menu não pode ser alterado. Ele só pode ser definido no momento da criação.": "Dopo la creazione, il tipo di menu non può essere modificato. Può essere definito solo al momento della creazione.",
    "menus.Pré-aquecimento do grupo": "Preriscaldamento del gruppo",
    "menus.Atenção: antes de transferir o menu de seu pen drive para o equipamento, é necessário descompactar o arquivo, transferindo a pasta PRATICA para o equipamento.": "Attenzione: prima di trasferire il menu dalla chiavetta USB all'apparecchiatura, è necessario estrarre il file e trasferire la cartella PRATICA sull'apparecchiatura.",
    "menus.Tamanho máximo": "Dimensione massima",
    "menus.Possibilita que o operador do forno crie parâmetros e os execute em seguida.": "Consente all'operatore del forno di creare parametri ed eseguirli successivamente.",
    "menus.Acesso também à execução das receitas favoritas.": "Consente anche l'accesso all'esecuzione delle ricette preferite.",
    "menus.Possibilita que o operador adicione mais tempo para aquecer/dourar a refeição depois de sua execução.": "Consente all'operatore di aggiungere tempo extra per riscaldare/dorare il pasto dopo l'esecuzione.",
    "menus.Possibilita a repetição da receita assim que sua execução é finalizada.": "Consente di ripetere la ricetta non appena l'esecuzione è terminata.",
    "menus.Acesso exclusivo às receitas favoritas.": "Accesso esclusivo alle ricette preferite.",
    "menus.Habilita o lembrete para o operador conferir se o alimento já está dentro do forno.": "Abilita un promemoria affinché l'operatore verifichi che l'alimento sia già all'interno del forno.",
    "menus.O forno importa automaticamente, ao ligar, um menu que esteja salvo em pen drive e nele inserido.": "All'accensione, il forno importa automaticamente un menu salvato e inserito tramite chiavetta USB.",
    "menus.Possibilita a cocção de diversos alimentos simultaneamente, um em cada GN.": "Consente la cottura simultanea di diversi alimenti, uno per ogni GN.",
    "menus.Permite a execução de receitas pré programadas, vindas de fábrica.": "Consente l'esecuzione di ricette preprogrammate fornite dal produttore.",
    "menus.Permite acesso à função turbo grill, que atinge até 300°C.": "Consente l'accesso alla funzione Turbo Grill, che raggiunge fino a 300°C.",
    "menus.Possibilita que o operador adicione mais tempo para dourar a refeição depois de sua execução.": "Consente all'operatore di aggiungere più tempo per dorare il pasto dopo l'esecuzione.",
    "menus.Permite que o operador edite grupos de receitas diretamente da tela inicial.": "Consente all'operatore di modificare i gruppi di ricette direttamente dalla schermata iniziale.",
    "menus.Copiar grupos": "Copia gruppi",
    "menus.Excluir grupos": "Elimina gruppi",
    "menus.Copiar": "Copia",
    "menus.Selecione grupos para copiar": "Seleziona i gruppi da copiare",
    "menus.Selecione o destino dos grupos": "Seleziona la destinazione dei gruppi",
    "menus.Colar": "Incolla",
    "menus.Deseja cancelar a cópia e envio de grupos para os menus?": "Desideri annullare la copia e l'invio dei gruppi ai menu?",
    "menus.Grupos colados com sucesso": "{count, plural, one {Gruppo incollato con successo!} other {Gruppi incollati con successo!}}",
    "menus.Copiar receitas": "Copia ricette",
    "menus.Selecione receitas para copiar": "Seleziona le ricette da copiare",
    "menus.Selecione o destino das receitas": "Seleziona la destinazione delle ricette",
    "menus.Deseja cancelar a cópia e envio de receitas para os grupos?": "Desideri annullare la copia e l'invio delle ricette ai gruppi?",
    "menus.Receitas coladas com sucesso": "{count, plural, one {Ricetta incollata con successo!} other {Ricette incollate con successo!}}",
    "menus.Converter para C-MAX EVO": "Converti in C-MAX EVO",
    "menus.Uma cópia deste menu, adaptada para o C-MAX EVO, será criada. Recomendamos que revise cuidadosamente todos os parâmetros dos passos e atualize as receitas com novas imagens, se julgar necessário.": "Verrà creata una copia di questo menu adattata per il C-MAX EVO. Ti consigliamo di verificare attentamente tutti i parametri dei passaggi e aggiornare le ricette con nuove immagini, se necessario.",
    "menus.Menu convertido com sucesso!": "Menu convertito con successo!",
    "menus.Não foi possível converter o menu. Tente novamente mais tarde": "Impossibile convertire il menu. Riprova più tardi.",
    "menus.O menu está sendo convertido... Aguarde!": "Il menu è in fase di conversione... Attendere!",
    "menus.Menu incompatível com": "Menu incompatibile con",
    "menus.Selecione pelo menos um grupo": "Seleziona almeno un gruppo",
    "menus.Selecione pelo menos um menu": "Seleziona almeno un menu",
    "menus.Menu atual": "Menu attuale",
    "menus.Copiando grupos": "{count, plural, one {Il gruppo è in fase di copia... Attendere!} other {I gruppi sono in fase di copia... Attendere!}}",
    "menus.Erro ao copiar grupos": "{count, plural, one {Impossibile copiare il gruppo. Riprova più tardi!} other {Impossibile copiare i gruppi. Riprova più tardi!}}",
    "menus.Procurar pelo nome do menu": "Cerca per nome del menu",
    "menus.Escolha um grupo de destino para cada menu selecionado": "Scegli un gruppo di destinazione per ogni menu selezionato!",
    "menus.Copiando receitas": "{count, plural, one {La ricetta è in fase di copia... Attendere!} other {Le ricette sono in fase di copia... Attendere!}}",
    "menus.Erro ao copiar receitas": "{count, plural, one {Impossibile copiare la ricetta. Riprova più tardi!} other {Impossibile copiare le ricette. Riprova più tardi!}}",
    "menus.SELECIONE GRUPOS PARA EXCLUIR": "SELEZIONA I GRUPPI DA ELIMINARE",
    "menus.Padeiro noturno": "Panettiere notturno",
    "menus.Permite programar o início (pré-aquecimento) de uma receita específica ou informada manualmente (Modo Manual), sem a necessidade de presença de um operador no local.": "Consente di programmare l'avvio (preriscaldamento) di una ricetta specifica o inserita manualmente (Modalità Manuale), senza la necessità della presenza di un operatore sul posto.",
    "menus.Vaporizador": "Vaporizzatore",
    "menus.Editar receitas": "Modificare ricette",
    "menus.Permite que o operador edite receitas diretamente da tela inicial.": "Consente all'operatore di modificare le ricette direttamente dalla schermata iniziale.",
    "menus.Preencha o nome da receita": "Inserisci il nome della ricetta",
    "menus.Tempo nível": "Tempo livello",
    "menus.Fermentadora": "Camera di lievitazione",
    "menus.0 ou 5 a 59s": "0 oppure da 5 a 59 s",
    "menus.Selecione uma imagem": "Seleziona un'immagine",
    "menus.*Para criar receitas para fornos sem conectividade, crie um menu e então as receitas.": "*Per creare ricette per forni senza connettività, crea prima un menu e poi le ricette.",
    "menus.CONVERTER": "CONVERTI",
    "menus.Converter para FIT": "Converti in FIT",
    "menus.Converter para outro FIT": "Converti in un altro FIT",
    "menus.Selecione pelo menos um modelo FIT": "Seleziona almeno un modello FIT",
    "menus.O menu está sendo convertido para FIT... Aguarde!": "Il menu è in fase di conversione in FIT... Attendere!",
    "menus.{count} menu(s) convertido(s) com sucesso para FIT!": "{count} menu convertito/i con successo in FIT!",
    "menus.Alguns menus foram convertidos, mas houve falha em: {models}": "Alcuni menu sono stati convertiti, ma si è verificato un errore per: {models}",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos.": "Verrà creata una copia di questo menu per ogni modello FIT selezionato, mantenendo configurazioni, gruppi, ricette e passaggi.",
    "menus.Uma cópia deste menu será criada para cada modelo FIT selecionado, mantendo configurações, grupos, receitas e passos. No entanto, como cada forno possui dimensões e características específicas, recomendamos revisar e ajustar os parâmetros para garantir o melhor desempenho e resultado em cada equipamento. Selecione o modelo da linha FIT para qual deseja converter o menu.": "Verrà creata una copia di questo menu per ogni modello FIT selezionato, mantenendo configurazioni, gruppi, ricette e passaggi. Tuttavia, poiché ogni forno ha dimensioni e caratteristiche specifiche, consigliamo di verificare e regolare i parametri per garantire le migliori prestazioni e risultati su ciascuna apparecchiatura. Seleziona il modello della linea FIT nel quale desideri convertire il menu.",
    
    //COOKBOOK
    "cookbook.RECEITAS DISPONÍVEIS": "RICETTE DISPONIBILI",
    "cookbook.RECEITAS SALVAS": "RICETTE SALVATE",
    "cookbook.ENVIAR PARA MENU": "INVIA AL MENU",
    "cookbook.SALVAR": "SALVA",
    "cookbook.salvar": "salva",
    "cookbook.Filtrar por": "Filtra per",
    "cookbook.Procurar receita do cookbook": "Cerca una ricetta nel Cookbook",
    "cookbook.Equipamento": "Apparecchiatura",
    "cookbook.Ingrediente principal": "Ingrediente principale",
    "cookbook.Tipo de prato": "Tipo di piatto",
    "cookbook.Região": "Regione",
    "cookbook.Pré-aquecimento": "Preriscaldamento",
    "cookbook.Procurar receita": "Cerca ricetta",
    "cookbook.Menu": "Menu",
    "cookbook.ENVIAR": "INVIA",
    "cookbook.Procurar nome do menu": "Cerca il nome del menu",
    "cookbook.Escolha um grupo deste menu": "Scegli un gruppo di questo menu",
    "cookbook.Selecionar grupo": "Seleziona gruppo",
    "cookbook.Tivemos um problema. Tente novamente mais tarde": "Si è verificato un problema. Riprova più tardi",
    "cookbook.Receita adicionada com sucesso!": "Ricetta aggiunta con successo!",
    "cookbook.Não foi possível adicionar a receita. Tente novamente mais tarde": "Impossibile aggiungere la ricetta. Riprova più tardi",
    "cookbook.Selecione um menu e um grupo para enviar esta receita": "Seleziona un menu e un gruppo per inviare questa ricetta",
    "cookbook.A receita não foi adicionada ao menu pois não há grupos criados": "La ricetta non è stata aggiunta al menu perché non sono stati creati gruppi",
    "cookbook.Selecione o modelo do equipamento primeiro": "Seleziona prima il modello dell'apparecchiatura",
    "cookbook.Grupo": "Gruppo",
    "cookbook.Não foi possível salvar os passos da receita": "Impossibile salvare i passaggi della ricetta",
    "cookbook.Bovina": "Manzo",
    "cookbook.Frango": "Pollo",
    "cookbook.Ovos": "Uova",
    "cookbook.Pães": "Pane",
    "cookbook.Peixes": "Pesce",
    "cookbook.Queijo": "Formaggio",
    "cookbook.Suína": "Maiale",
    "cookbook.Vegetais": "Verdure",
    "cookbook.Outros": "Altri",
    "cookbook.Entradas/aperitivos": "Antipasti",
    "cookbook.Principais": "Piatti principali",
    "cookbook.Snacks": "Snack",
    "cookbook.Pizzas": "Pizze",
    "cookbook.Massas": "Paste",
    "cookbook.Acompanhamentos": "Contorni",
    "cookbook.Sobremesas": "Dessert",
    "cookbook.Manhã": "Colazione",
    "cookbook.Padaria": "Panetteria",
    "cookbook.Todos": "Tutti",
    "cookbook.Não atribuir origem": "Non assegnare origine",
    "cookbook.Brasil": "Brasile",
    "cookbook.Alemanha": "Germania",
    "cookbook.França": "Francia",
    "cookbook.Rússia": "Russia",
    "cookbook.China": "Cina",
    "cookbook.Japão": "Giappone",
    "cookbook.Itália": "Italia",
    "cookbook.Egito": "Egitto",
    "cookbook.Grécia": "Grecia",
    "cookbook.Argentina": "Argentina",
    "cookbook.África": "Africa",
    "cookbook.Estados Unidos": "Stati Uniti",
    "cookbook.Coreia": "Corea",
    "cookbook.Turquia": "Turchia",
    "cookbook.Ideal para": "Ideale per",
    "cookbook.Polônia": "Polonia",
    "cookbook.Sanduíches": "Panini",
    "cookbook.Nova Receita": "Nuova ricetta",
    
    //EQUIPAMENTOS
    "equipment.equipamentos": "attrezzature",
    "equipment.procurar equipamento": "Cerca attrezzatura o utente",
    "equipment.adicionar equipamento": "aggiungi attrezzatura",
    "equipment.atualizar equipamento": "aggiorna attrezzatura",
    "equipment.+ equipamentos": "+ attrezzature",
    "equipment.buscar equipamento": "Cerca attrezzatura",
    "equipment.Desvincular": "Disassocia",
    "equipment.Editar": "Modifica",
    "equipment.sem conteúdo": "NON CI SONO ANCORA ATTREZZATURE QUI :(",
    "equipment.description.sem conteúdo": "Fai clic sul pulsante Aggiungi Attrezzatura, situato nell'angolo superiore destro, e collega i tuoi forni.",
    "equipment.editar equipamento": "modifica attrezzatura",
    "equipment.equipamento editado com sucesso!": "Attrezzatura modificata con successo!",
    "equipment.não foi possível editar o equipamento. Tente novamente mais tarde": "Non è stato possibile modificare l'attrezzatura. Riprova più tardi.",
    "equipment.Menu exportado com sucesso!": "Menu esportato con successo!",
    "equipment.Não foi possível exportar o menu. Tente novamente mais tarde": "Non è stato possibile esportare il menu. Riprova più tardi.",
    "equipment.Selecione pelo menos um equipamento para enviar o menu": "Seleziona almeno un'attrezzatura per inviare il menu",
    "equipment.Informações do menu": "Informazioni del menu",
    "equipment.Procurar receita ou grupo": "Cerca ricetta o gruppo",
    "equipment.Grupo": "Gruppo",
    "equipment.Grupos de equipamentos": "Gruppi di apparecchiature",
    "equipment.Receita": "Ricetta",
    "equipment.Quantidade": "Quantità",
    "equipment.Receitas mais preparadas no equipamento durante o período": "Ricette più eseguite sull'attrezzatura nel periodo",
    "equipment.Informações de limpeza": "Informazioni sulla pulizia",
    "equipment.Data da limpeza": "Data della pulizia",
    "equipment.Hora da limpeza": "Ora della pulizia",
    "equipment.nome": "Nome",
    "equipment.modelo": "Modello",
    "equipment.categoria": "Categoria",
    "equipment.loja": "Punto vendita",
    "desvincular equipamento": "Disassocia attrezzatura",
    "equipment.unlink.paragrafo 1": "Desideri disassociare l'attrezzatura dalla piattaforma IOK?",
    "equipment.unlink.paragrafo 2": "In questo modo non sarà più possibile gestire le sue configurazioni e il suo menu tramite la piattaforma, a meno che l'attrezzatura non venga collegata nuovamente seguendo le istruzioni di connessione.",
    "equipamento desvinculado com sucesso!": "Attrezzatura disassociata con successo!",
    "equipment.ocorreu um erro. Tente novamente mais tarde": "Si è verificato un errore. Riprova più tardi.",
    "equipment.sim": "Sì",
    "equipment.não": "No",
    "equipment.Encerrar acesso remoto": "Terminare accesso remoto",
    "equipment.Horas sem limpeza": "Ore senza pulizia",
    "equipment.Histórico de eventos": "Storico eventi",
    "equipment.Histórico de eventos do forno": "Storico eventi del forno",
    "equipment.Histórico de eventos da fermentadora": "Storico eventi della camera di lievitazione",
    "equipment.Receitas executadas": "Ricette eseguite",
    "equipment.Hoje": "Oggi",
    "equipment.Tempo de porta aberta": "Tempo porta aperta",
    "equipment.Tempo médio aproximado": "Tempo medio approssimativo",
    "equipment.Filtrar eventos": "Filtra eventi",
    "equipment.Evento": "Evento",
    "equipment.Data": "Data",
    "equipment.ERRO SENSOR RI": "Errore sensore resistenza inferiore",
    "equipment.ERRO COM INV. DE FREQ.": "Errore inverter di frequenza",
    "equipment.ERRO MAGNETRON": "Errore magnetron",
    "equipment.ERRO SENSOR CAMARA": "Errore sensore camera",
    "equipment.ERRO CAN": "Errore CAN",
    "equipment.Erro INVERSOR DE FREQUENCIA": "Errore inverter di frequenza",
    "equipment.ERRO DO MODELO DO EQUIPAMENTO": "Errore modello attrezzatura",
    "equipment.ERRO PAINEL": "Errore pannello",
    "equipment.ERRO INV.FREQ.STATUS": "Errore stato inverter di frequenza",
    "equipment.ERRO SENSOR BOARD": "Errore sensore scheda",
    "equipment.ERRO ENERGY": "Errore energia",
    "equipment.ERRO I2C": "Errore I2C",
    "equipment.EQUIPAMENTO LIGADO": "Attrezzatura accesa",
    "equipment.EQUIPAMENTO DESLIGADO": "Attrezzatura spenta",
    "equipment.Plataforma": "Piattaforma",
    "equipment.Forno": "Forno",
    "equipment.Origem": "Origine",
    "equipment.Locais": "Posizioni",
    "equipment.não foi possível carregar as entidades": "Non è stato possibile caricare le entità",
    "equipment.conceder acesso remoto a": "Concedere accesso remoto a",
    "equipment.atualizar software": "aggiorna software",
    "equipment.suporte": "supporto",
    "equipment.PIN": "PIN",
    "equipment.nome do equipamento": "Nome dell'attrezzatura",
    "equipment.vinculado à loja": "Associato al punto vendita",
    "equipment.cadastrar loja": "Registrare punto vendita",
    "equipment.informe o PIN do forno": "Inserisci il PIN del forno",
    "equipment.preencha o PIN do forno": "Compila il PIN del forno",
    "equipment.adicione um nome para facilitar seu reconhecimento": "Aggiungi un nome per facilitarne il riconoscimento",
    "equipment.preencha o nome do equipamento": "Compila il nome dell'attrezzatura",
    "equipment.selecionar": "Selezionare",
    "equipment.nome fantasia": "Nome commerciale",
    "equipment.informe o nome fantasia": "Inserisci il nome commerciale",
    "equipment.preencha o nome fantasia": "Compila il nome commerciale",
    "equipment.CNPJ": "CNPJ",
    "equipment.XX.XXX.XXX/0001.XX": "XX.XXX.XXX/0001.XX",
    "equipment.preencha o CNPJ": "Compila il CNPJ",
    "equipment.CEP": "CAP",
    "equipment.00000-000": "00000-000",
    "equipment.preencha o CEP": "Compila il CAP",
    "equipment.cidade": "Città",
    "equipment.informe a cidade": "Inserisci la città",
    "equipment.preencha a cidade": "Compila la città",
    "equipment.UF": "Provincia",
    "equipment.bairro": "Quartiere",
    "equipment.informe o bairro": "Inserisci il quartiere",
    "equipment.endereço": "Indirizzo",
    "equipment.informe o seu endereço": "Inserisci il tuo indirizzo",
    "equipment.preencha o seu endereço": "Compila il tuo indirizzo",
    "equipment.Nº": "N.",
    "equipment.equipamento cadastrado com sucesso!": "Attrezzatura registrata con successo!",
    "equipment.ocorreu um erro": "Si è verificato un errore",
    "equipment.preencha o modelo": "Compila il modello",
    "equipment.selecione uma categoria": "Seleziona una categoria",
    "equipment.selecione uma loja": "Seleziona un punto vendita",
    "equipment.preencha o bairro": "Compila il quartiere",
    "equipment.não foi possível cadastrar o equipamento. Tente novamente mais tarde": "Non è stato possibile registrare l'attrezzatura. Riprova più tardi",
    "equipment.loja cadastrada com sucesso": "Punto vendita registrato con successo",
    "equipment.não foi possível cadastrar a loja. Tente novamente mais tarde": "Non è stato possibile registrare il punto vendita. Riprova più tardi",
    "equipment.equipment": "attrezzature",
    "equipment.search equipment": "cerca attrezzatura",
    "equipment.add equipment": "aggiungi attrezzatura",
    "equipment.update equipment": "aggiorna attrezzatura",
    "equipment.plus equipment": "+ attrezzatura",
    "equipment.Procurar equipamento": "Cerca attrezzatura",
    "equipment.EQUIPAMENTOS": "ATTREZZATURE",
    "equipment.Atualizar equipamento": "Aggiorna attrezzatura",
    "equipment.Atualizar equipamentos": "Aggiorna attrezzature",
    "equipment.confirmar": "conferma",
    "equipment.Selecione os modelos que deseja atualizar:": "Seleziona i modelli che desideri aggiornare:",
    "equipment.Como deseja realizar a atualização?": "Come desideri eseguire l'aggiornamento?",
    "equipment.Enviar atualização pela plataforma (internet)": "Inviare l'aggiornamento tramite la piattaforma (internet)",
    "equipment.Salvar arquivo de atualização no dispositivo": "Salvare il file di aggiornamento sul dispositivo",
    "equipment.Linha Express": "Linea Express",
    "equipment.Escolha como deseja realizar a atualização": "Scegli come desideri eseguire l'aggiornamento",
    "equipment.Selecione ao menos um modelo de equipamento para atualizar": "Seleziona almeno un modello di attrezzatura da aggiornare",
    "equipment.Status: ": "Stato: ",
    "equipment.Número de série:": "Numero di serie:",
    "equipment.Menu:": "Menu:",
    "equipment.Status:": "Stato:",
    "equipment.Número de série": "Numero di serie",
    "equipment.Menu": "Menu",
    "equipment.Loja: ": "Punto vendita: ",
    "equipment.End:": "Ind.: ",
    "equipment.Endereço:": "Indirizzo: ",
    "equipment.Cidade:": "Città: ",
    "equipment.CEP:": "CAP: ",
    "equipment.Atualização de software enviada com sucesso!": "Aggiornamento software inviato con successo!",
    "equipment.Não foi possível enviar a atualização de software. Tente novamente mais tarde": "Non è stato possibile inviare l'aggiornamento software. Riprova più tardi",
    "equipment.Download realizado com sucesso": "Download completato con successo",
    "equipment.Não foi possível realizar o download. Tente novamente mais tarde": "Non è stato possibile completare il download. Riprova più tardi",
    "equipment.Solicitação processada com erro. Tente novamente mais tarde": "Richiesta elaborata con errore. Riprova più tardi",
    "equipment.Preencha o nome da versão": "Inserisci il nome della versione",
    "equipment.Informe aqui todas as alterações desta nova versão": "Inserisci qui tutte le modifiche di questa nuova versione",
    "equipment.Nova versão de software atualizada com sucesso!": "Nuova versione software aggiornata con successo!",
    "equipment.Informe pelo menos uma mudança nesta versão": "Inserisci almeno una modifica in questa versione",
    "equipment.Falha ao transformar o arquivo em Blob": "Errore durante la conversione del file in Blob",
    "equipment.Erro ao criar Blob a partir do arquivo": "Errore durante la creazione del Blob dal file",
    "equipment.Falha ao ler o arquivo": "Errore durante la lettura del file",
    "equipment.selecionar tipo": "seleziona tipo",
    "equipment.selecione o tipo da versão": "seleziona il tipo di versione",
    "equipment.atualização": "AGGIORNAMENTO",
    "equipment.Selecione abaixo o que deseja fazer:": "Seleziona qui sotto cosa desideri fare:",
    "equipment.Atualizar meus equipamentos": "Aggiornare le mie attrezzature",
    "equipment.Enviar atualização para usuários selecionados": "Inviare aggiornamento agli utenti selezionati",
    "equipment.ENVIAR": "INVIA",
    "equipment.ENVIAR ATUALIZAÇÃO": "INVIA AGGIORNAMENTO",
    "equipment.Selecione os e-mails para os quais deseja enviar a atualização:": "Seleziona gli indirizzi e-mail ai quali desideri inviare l'aggiornamento:",
    "equipment.A atualização disponibilizada no dia": "L'aggiornamento reso disponibile il giorno",
    "equipment.referente ao equipamento": "relativo all'attrezzatura",
    "equipment.contempla o seguinte:": "comprende quanto segue:",
    "equipment.Selecionar arquivo para envio": "Seleziona file da inviare",
    "equipment.Por favor, selecione um arquivo .tar": "Seleziona un file .tar",
    "equipment.Selecione o modelo do equipamento:": "Seleziona il modello dell'attrezzatura:",
    "equipment.Selecione uma opção": "Seleziona un'opzione",
    "equipment.Nomeie a versão": "Assegna un nome alla versione",
    "equipment.Clique sobre o arquivo que deseja baixar:": "Fai clic sul file che desideri scaricare:",
    "equipment.Baixar atualização": "Scarica aggiornamento",
    "equipment.Versões": "Versioni",
    "equipment.e superiores": "e superiori",
    "equipment.name": "nome",
    "equipment.model": "modello",
    "equipment.category": "categoria",
    "equipment.store": "punto vendita",
    "FIT Express/FIT ST": "FIT Express/FIT ST",
    "Copa/Single Mag/Rocket": "Copa/Single Mag/Rocket",
    "Forza STi": "Forza STi",
    "TSi": "TSi",
    "FIT Express": "FIT Express",
    "FIT ST": "FIT ST",
    "FIT Express, FIT ST": "FIT Express, FIT ST",
    "Copa Express, Rocket Express, Copa Single Mag": "Copa Express, Rocket Express, Copa Single Mag",
    "equipment.e": "e",
    "equipment.Últimas versões de software:": "Ultime versioni software:",
    "equipment.Você não possui nenhum equipamento desatualizado": "Non hai nessuna attrezzatura non aggiornata",
    "equipment.grupos": "gruppi",
    "equipment.não foi possível carregar os grupos de equipamentos da companhia": "Non è stato possibile caricare i gruppi di attrezzature dell'azienda",
    "equipment.vinculado ao grupo": "Associato al gruppo",
    "equipment.selecione um grupo": "Seleziona un gruppo",
    "equipment.cadastrar grupo": "Registrare gruppo",
    "equipment.Número de Série": "NS",
    "equipment.Versão": "Versione",
    "equipment.não foi possível cadastrar o equipamento. Selecione ou cadastre um grupo": "Non è stato possibile registrare l'attrezzatura. Seleziona o registra un gruppo",
    "equipment.CRIE GRUPOS DE EQUIPAMENTOS!": "CREA GRUPPI DI ATTREZZATURE!",
    "equipment.Para que os usuários vinculados à conta possam visualizar os equipamentos você precisa:": "Affinché gli utenti associati all'account possano visualizzare le attrezzature, è necessario:",
    "equipment.1) Criar grupo(s);": "1) Creare uno o più gruppi;",
    "equipment.2) Atribuir equipamento(s) ao grupo;": "2) Assegnare una o più attrezzature al gruppo;",
    "equipment.3) Atribuir usuário(s) ao grupo.": "3) Assegnare uno o più utenti al gruppo.",
    "equipment.Status software": "Stato software",
    "equipment.Status menu": "Stato menu",
    "equipment.Pendente": "In sospeso",
    "equipment.Aceito": "Accettato",
    "equipment.Recusado": "Rifiutato",
    "equipment.Atualizar software": "Aggiorna software",
    "equipment.Deseja enviar a atualização para o equipamento selecionado?": "Desideri inviare l'aggiornamento all'attrezzatura selezionata?",
    "equipment.Companhia": "Azienda",
    "equipment.Exportar menu": "Esporta menu",
    "equipment.companhias": "aziende",
    "equipment.Nome da companhia": "Nome dell'azienda",
    "equipment.Procurar equipamento, usuário ou companhia": "Cerca attrezzatura, utente o azienda",
    "equipment.Versão da power": "Versione della scheda power",
    "equipment.AINDA NÃO HÁ DADOS DE RECEITAS AQUI :(": "NON CI SONO ANCORA DATI DELLE RICETTE QUI :(",
    "equipment.AINDA NÃO HÁ DADOS DE LIMPEZAS AQUI :(": "NON CI SONO ANCORA DATI DELLE PULIZIE QUI :(",
    "equipment.AINDA NÃO HÁ DADOS DE EVENTOS AQUI :(": "NON CI SONO ANCORA DATI DEGLI EVENTI QUI :(",
    "ID": "ID",
    "equipment.Hora": "Ora",
    "equipment.EVENTOS MAIS OCORRIDOS NO EQUIPAMENTO DURANTE O PERÍODO": "EVENTI PIÙ FREQUENTI SULL'ATTREZZATURA DURANTE IL PERIODO",
    "equipment.hour": "h",
    "equipment.minutes": "min",
    "equipment.date format": "GG/MM/AAAA",
    "equipment.preparada": "eseguita",
    "equipment.vezes": "volte",
    "equipment.vez": "volta",
    "equipment.Ver": "Visualizza",
    "equipment.Os dados são mantidos pela plataforma pelo tempo necessário para suporte, manutenção e evolução dos produtos.": "I dati vengono conservati dalla piattaforma per il tempo necessario al supporto, alla manutenzione e all'evoluzione dei prodotti.",
    "equipment.Ligado": "Acceso",
    "equipment.Desligado": "Spento",
    "equipment.CAN ERROR": "Errore CAN",
    "equipment.CAMERA SENSOR ERROR": "Errore sensore camera",
    "equipment.STEAM/RI SENSOR ERROR": "Errore sensore RI",
    "equipment.PROBE 1 ERROR": "Allarme sonda 1",
    "equipment.PROBE 2 ERROR": "Allarme sonda 2",
    "equipment.PROBE 3 ERROR": "Allarme sonda 3",
    "equipment.PROBE 4 ERROR": "Allarme sonda 4",
    "equipment.PROBE 5 ERROR": "Allarme sonda 5",
    "equipment.PROBE 6 ERROR": "Allarme sonda 6",
    "equipment.GENERAL PROBE ERROR": "Errore generale sonda",
    "equipment.WATER LACK ERROR": "Allarme mancanza d'acqua",
    "equipment.HIGH PANEL TEMPERATURE ERROR": "Allarme temperatura elevata del pannello",
    "equipment.FREQUENCY INVERTER GENERAL ERROR": "Errore generale inverter di frequenza",
    "equipment.FREQUENCY INVERTER COMMUNICATION ERROR": "Allarme comunicazione inverter di frequenza",
    "equipment.FREQUENCY INVERTER STATUS ERROR": "Allarme stato inverter di frequenza",
    "equipment.CLEANING NOT COMPLETED ERROR": "Allarme pulizia incompleta",
    "equipment.MAGNETRON ERROR": "Allarme magnetron",
    "equipment.EQUIPMENT FAMILY/MODEL ERROR": "Errore famiglia/modello dell'attrezzatura",
    "equipment.BOARD TEMPERATURE SENSOR ERROR": "Allarme sensore temperatura scheda",
    "equipment.ENERGY MODULE ERROR": "Errore modulo energia",
    "equipment.POWER BOARD I2C BUS ERROR": "Errore scheda power",
    "equipment.GAS SYSTEM ERROR": "Errore gas",
    "equipment.VERY HIGH PANEL TEMPERATURE ERROR": "Errore temperatura estremamente elevata del pannello",
    "equipment.POWER ON": "Acceso",
    "equipment.POWER OFF": "Spento",
    "equipment.DOOR OPENED": "Porta aperta",
    "equipment.DOOR CLOSED": "Porta chiusa",
    "equipment.CLEANING CANCELED ERROR": "Pulizia annullata dall'utente",
    "equipment.PIN não encontrado. Por favor, verifique e tente novamente": "PIN non trovato. Verifica e riprova",
    "equipment.Ultracongeladores": "Abbattitori",
    "equipment.PIN já vinculado a outra conta": "Il PIN è già collegato a un altro account",
    "equipment.Equipamento já cadastrado nesta conta": "L’attrezzatura è già registrata su questo account",
    "equipment.Não foi possível validar o PIN. Tente novamente": "Non è stato possibile convalidare il PIN. Riprova",
    "equipment.Modelo definido pelo equipamento": "Definito dall'apparecchiatura",
    "equipment.Número de série offline inválido": "Inserisci sette cifre, senza spazi o zero iniziale",
    "equipment.Número de série já cadastrado": "Numero di serie già registrato",
    "equipment.Online": "Acceso",
    "equipment.Offline": "Spento",
    "equipment.Exibir apenas eventos": "Mostra solo eventi",
    "equipment.Endereço": "Indirizzo",
    "equipment.EQUIPMENT CONNECTED TO THE PLATFORM": "Attrezzatura connessa alla piattaforma",
    "equipment.EQUIPMENT DISCONNECTED FROM THE PLATFORM": "Attrezzatura disconnessa dalla piattaforma",
    "equipment.MENU RECEIVED FROM THE PLATFORM": "Menu della piattaforma accettato dall'utente",
    "equipment.MENU REJECTED BY THE USER": "Menu della piattaforma rifiutato dall'utente",
    "equipment.CONNECTED TO THE INTERNET": "Connesso a Internet",
    "equipment.DISCONNECTED FROM THE INTERNET": "Disconnesso da Internet",
    "equipment.Infelizmente, não há versões compatíveis com este equipamento que realizem o envio de dados.": "Purtroppo non esistono versioni compatibili con questa attrezzatura che consentano l'invio dei dati.",
    "equipment.O equipamento": "L'attrezzatura",
    "equipment.deve ser atualizado para a versão mais recente de software para que passe a enviar os dados para a plataforma": "deve essere aggiornata all'ultima versione software per poter inviare i dati alla piattaforma",
    "equipment.Versão do seu equipamento": "Versione della tua attrezzatura",
    "equipment.Versão disponível": "Versione disponibile",
    "equipment.Selecione abaixo como deseja enviar a atualização para seu equipamento": "Seleziona qui sotto come desideri inviare l'aggiornamento alla tua attrezzatura",
    "equipment.Salvar no dispositivo": "Salva sul dispositivo",
    "equipment.Enviar pela internet": "Invia tramite Internet",
    "equipment.Cliente": "Cliente",
    "equipment.NÚMERO DE SÉRIE NÃO ENCONTRADO": "NUMERO DI SERIE NON TROVATO",
    "equipment.BUSCAR": "CERCA",
    "equipment.ACESSADOS RECENTEMENTE": "ACCESSI RECENTI",
    "equipment.SEM BUSCAS RECENTES": "NESSUNA RICERCA RECENTE",
    "equipment.description.SEM BUSCAS RECENTES": "Utilizza il numero di serie per cercare le attrezzature.",
    "equipment.Procurar equipamento pelo número de série": "Cerca attrezzatura tramite numero di serie",
    "equipment.AIR FILTER CLEANING COMPLETED": "Pulizia del filtro dell'aria completata",
    "equipment.AIR FILTER CLEANING REJECTED": "Pulizia del filtro dell'aria rifiutata",
    "equipment.CATALYTIC FILTER CLEANING COMPLETED": "Pulizia del filtro catalitico completata",
    "equipment.CATALYTIC FILTER CLEANING REJECTED": "Pulizia del filtro catalitico rifiutata",
    "equipment.Endereço (rua, avenida, rodovia)": "Indirizzo (via, viale, strada)",
    "equipment.Nº/Km": "Nº/Km",
    "equipment.ID do equipamento": "ID dell'attrezzatura",
    "equipment.Todo equipamento deve ser vinculado a um grupo. Selecione um grupo da lista ou cadastre um novo clicando em + Cadastrar grupo.": "Ogni attrezzatura deve essere associata a un gruppo. Seleziona un gruppo dall'elenco oppure registrane uno nuovo cliccando su + Registra gruppo.",
    "equipment.Nomeie seu forno": "Assegna un nome al tuo forno",
    "equipment.Para visualizar o PIN, acesse nas configurações do equipamento a Plataforma Virtual IOK.": "Per visualizzare il PIN, accedi alla Piattaforma Virtuale IOK nelle impostazioni dell'attrezzatura.",
    "equipment.Vinculação IOK": "Associazione IOK",
   "equipment.Preparações": "Esecuzioni",
    "equipment.recipeTable.recipe": "Ricetta",
    "equipment.recipeTable.origin": "Ori.",
    "equipment.recipeTable.executions": "Esec.",
    "equipment.recipeTable.lastExecution": "Ultima esecuzione",
    "equipment.Última preparação": "Ultima esecuzione",
    "equipment.localização": "posizione",
    "equipment.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "NON CI SONO ANCORA POSIZIONI REGISTRATE :(",
    "equipment.description.AINDA NÃO HÁ NENHUMA LOCALIZAÇÃO CADASTRADA :(": "Clicca sul pulsante situato nell'angolo superiore destro e aggiungi delle posizioni.",
    "equipment.Procurar empresa ou local": "Cerca azienda o posizione",
    "equipment.Adicionar localização": "Aggiungi posizione",
    "equipment.Adicionar": "Aggiungi",
    "equipment.espaço": "Spazio",
    "equipment.local": "Luogo",
    "equipment.EXCLUIR LOCALIZAÇÃO": "ELIMINA POSIZIONE",
    "equipment.Você deseja excluir esta localização?": "Desideri eliminare questa posizione?",
    "equipment.Ao fazer isso, os equipamentos atrelados à ela não exibirão nenhuma localização, sendo necessário informar um novo local para eles.": "In questo modo, le attrezzature associate non mostreranno alcuna posizione e sarà necessario assegnarne una nuova.",
    "equipment.Localização deletada com sucesso!": "Posizione eliminata con successo!",
    "equipment.Erro ao deletar a localização. Tente novamente mais tarde": "Errore durante l'eliminazione della posizione. Riprova più tardi.",
    "equipment.Não foi possivel deletar a localização": "Impossibile eliminare la posizione",
    "equipment.Localização adicionada com sucesso!": "Posizione aggiunta con successo!",
    "equipment.Não foi possível adicionar a localização. Tente novamente mais tarde": "Impossibile aggiungere la posizione. Riprova più tardi.",
    "equipment.Nome do espaço": "Nome dello spazio",
    "equipment.Informe o nome do espaço": "Inserisci il nome dello spazio",
    "equipment.Preencha o nome do espaço": "Compila il nome dello spazio",
    "equipment.país": "Paese",
    "equipment.informe o país": "Inserisci il paese",
    "equipment.preencha o país": "Compila il paese",
    "equipment.Localização editada com sucesso!": "Posizione modificata con successo!",
    "equipment.Não foi possível editar a localização. Tente novamente mais tarde": "Impossibile modificare la posizione. Riprova più tardi.",
    "equipment.Editar localização": "Modifica posizione",
    "equipment.Pico de preparações": "Picco di esecuzioni",
    "equipment.informações da semana": "informazioni della settimana",
    "equipment.horários de pico": "orari di punta",
    "equipment.horário de pico": "orario di punta",
    "equipment.preparações do dia": "esecuzioni del giorno",
    "equipment.Horário": "Orario",
    "equipment.dia selecionado": "giorno selezionato",
    "equipment.A limpeza adequada e diária do forno auxilia em seu funcionamento correto e impacta na garantia.": "Una pulizia corretta e quotidiana del forno contribuisce al suo corretto funzionamento e influisce sulla garanzia.",
    "equipment.Total de limpezas realizadas:": "Totale pulizie effettuate:",
    "equipment.Limpezas não concluídas:": "Pulizie non completate:",
    "equipment.Desde a vinculação do forno a IOK": "Dall'associazione del forno a IOK",
    "equipment.Equipamento ligado há:": "Attrezzatura accesa da:",
    "equipment.Total de receitas preparadas:": "Totale ricette eseguite:",
    "equipment.Receitas preparadas": "Ricette eseguite",
    "equipment.Aberturas de porta": "Aperture della porta",
    "equipment.Desde a última vez que o forno foi ligado": "Dall'ultima accensione del forno",
    "equipment.Preparação": "Esecuzione",
    "equipment.Nenhuma localização criada": "Nessuna posizione creata",
    "equipment.Acesso remoto": "Accesso remoto",
    "equipment.Informe o ID da empresa que poderá acessar remotamente seu forno. Use ; para separar IDs.": "Inserisci l'ID dell'azienda che potrà accedere da remoto al tuo forno. Usa ; per separare gli ID.",
    "equipment.O acesso remoto permite que as empresas selecionadas enviem menus e atualizações para seu equipamento.": "L'accesso remoto consente alle aziende selezionate di inviare menu e aggiornamenti alla tua attrezzatura.",
    "equipment.Concedo acesso remoto à Prática oficial.": "Concedo l'accesso remoto a Prática ufficiale.",
    "equipment.Deseja selecionar outros equipamentos vinculados à sua conta para conceder acesso remoto a eles?": "Desideri selezionare altre attrezzature associate al tuo account per concedere loro l'accesso remoto?",
    "equipment.Selecione abaixo os equipamentos para os quais deseja conceder acesso remoto à": "Seleziona qui sotto le attrezzature alle quali desideri concedere l'accesso remoto a",
    "equipment.Acesso remoto concedido com sucesso!": "Accesso remoto concesso con successo!",
    "equipment.Selecione pelo menos um equipamento": "Seleziona almeno un'attrezzatura",
    "equipment.Não foi possível editar os equipamentos. Tente novamente mais tarde": "Impossibile modificare le attrezzature. Riprova più tardi.",
    "equipment.Solicitar atendimento": "Richiedi assistenza",
    "equipment.Relate um problema": "Segnala un problema",
    "equipment.Descreva aqui o problema de seu equipamento": "Descrivi qui il problema della tua attrezzatura",
    "equipment.Não foi possível enviar sua solicitação de atendimento. Tente mais tarde": "Impossibile inviare la richiesta di assistenza. Riprova più tardi.",
    "equipment.Solicitação técnica enviada com sucesso!": "Richiesta tecnica inviata con successo!",
    "equipment.Enviar": "Invia",
    "equipment.Solicitação de atendimento": "Richiesta di assistenza",
    "equipment.Informe o problema de seu equipamento": "Descrivi il problema della tua attrezzatura",
    "equipment.Informações do magnetron": "Informazioni sul magnetron",
    "equipment.Vida útil aproximada": "Durata utile approssimativa",
    "equipment.MAGNETRON USAGE HOURS": "Ore di utilizzo del magnetron",
    "equipment.Atendimento": "Assistenza",
    "equipment.Eventos mais ocorridos no equipamento durante o período": "Eventi più frequenti sull'attrezzatura durante il periodo",
    "equipment.EQUIPAMENTO SEM NÚMERO DE SÉRIE": "ATTREZZATURA SENZA NUMERO DI SERIE",
    "equipment.Filtros": "Filtri",
    "equipment.Filtrar": "Filtra",
    "equipment.Limpar filtros": "Cancella filtri",
    "equipment.Procurar por modelo, versão ou país": "Cerca per modello, versione o paese",
    "equipment.Procurar equipamento, NS, modelo, versão ou país": "Cerca attrezzatura, NS, modello, versione o paese",
    "equipment.Os seguintes IDs não pertencem a uma companhia do tipo 'Distribuidor' e foram removidos": "I seguenti ID non appartengono a un'azienda di tipo 'Distributore' e sono stati rimossi",
    "equipment.BAIXAR VERSÕES": "SCARICA VERSIONI",
    "equipment.Compatível com todas as versões da IHM.": "Compatibile con tutte le versioni della IHM.",
    "equipment.Compatível apenas com a versão 2.0.0C da Power.": "Compatibile solo con la versione 2.0.0C della Power.",
    "equipment.Procurar evento": "Cerca evento",
    "equipment.Forno conectado": "Forno connesso",
    "equipment.Limpeza de filtro de ar": "Pulizia del filtro dell'aria",
    "equipment.Limpeza de filtro catalítico": "Pulizia del filtro catalitico",
    "equipment.Limpeza realizada": "Pulizia eseguita",
    "equipment.Limpeza recomendada": "Pulizia consigliata",
    "equipment.Forno ligado": "Forno acceso",
    "equipment.Inversor de frequência": "Inverter di frequenza",
    "equipment.Temperatura de painel": "Temperatura del pannello",
    "equipment.Sensor da câmara": "Sensore della camera",
    "equipment.Magnetron": "Magnetron",
    "equipment.Power": "Power",
    "equipment.Informações de menu": "Informazioni del menu",
    "equipment.Limpeza": "Pulizia",
    "equipment.O equipamento já está utilizando a versão mais recente do software.": "L'attrezzatura sta già utilizzando la versione più recente del software.",
    "equipment.Atenção: o cálculo da vida útil do magnetron não considera o tempo de uso anterior à versão F1.1.0.": "Attenzione: il calcolo della durata utile del magnetron non considera il tempo di utilizzo precedente alla versione F1.1.0.",
    "equipment.Equipamentos com erro": "Attrezzature con errore",
    "equipment.Em breve você terá acesso a dados importantes enviados pelo forno, como horário de pico, receitas mais executadas, histórico de higienizações, eventos ocorridos e mais! Lembre-se de manter seu equipamento sempre atualizado com as novas versões disponíveis na plataforma.": "Presto avrai accesso a importanti dati inviati dal forno, come gli orari di punta, le ricette più eseguite, lo storico delle pulizie, gli eventi registrati e molto altro! Ricorda di mantenere sempre aggiornata la tua attrezzatura con le nuove versioni disponibili sulla piattaforma.",
    "equipment.Para que a execução da limpeza seja registrada no equipamento e enviada à plataforma, é necessário seguir o passo a passo completo do procedimento no forno. Não é obrigatório assistir aos vídeos dos passos, quando disponíveis.": "Affinché l'esecuzione della pulizia venga registrata sull'attrezzatura e inviata alla piattaforma, è necessario seguire l'intera procedura passo dopo passo sul forno. Non è obbligatorio guardare i video dei passaggi, quando disponibili.",
    "equipment.Horas de uso": "Ore di utilizzo",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.0.6": "Il conteggio delle ore di utilizzo del magnetron viene effettuato a partire dalla versione F1.0.6",
    "equipment.A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.": "L'aggiornamento del software richiede circa 15 minuti. Durante il processo il forno si riavvierà e mostrerà una schermata blu fino al completamento. Per evitare errori, mantienilo acceso e connesso a Internet. Se scegli di aggiornare tramite chiavetta USB, non rimuoverla fino al termine.",
    'equipment.Equipamento {name} com software {version} devem ser atualizador via USB. A atualização do software leva cerca de 15 minutos. Durante o processo, o forno reiniciará e exibirá uma tela azul até a conclusão. Para evitar falhas, mantenha-o ligado e conectado à internet. Caso opte por atualizar via pen drive, não o remova até a conclusão.': "L'apparecchiatura {nome} con software {versione} deve essere aggiornata tramite USB. L'aggiornamento del software richiede circa 15 minuti. Durante il processo, il forno si riavvierà e visualizzerà una schermata blu fino al completamento. Per evitare errori, mantenerlo acceso e connesso a Internet. Se si sceglie di aggiornare tramite unità USB, non rimuoverla fino al completamento.",
    "equipment.Observação": "Nota:",
    "equipment.Para versões ST2.0.0 e superiores, o envio de atualização pela plataforma (Wi-fi) seguirá disponibilizado normalmente.": "Per le versioni ST2.0.0 e successive, l'invio dell'aggiornamento tramite la piattaforma (Wi-Fi) continuerà a essere disponibile normalmente.",
    "equipment.Aqui você encontra informações gerais sobre o equipamento;": "Qui trovi informazioni generali sull'attrezzatura;",
    "equipment.Ao clicar nestes botões você consegue solicitar atendimento para seu forno e exportar seus dados em planilhas do Excel;": "Facendo clic su questi pulsanti puoi richiedere assistenza per il tuo forno ed esportare i dati in fogli Excel;",
    "equipment.Nos quadros abaixo você encontra informações detalhadas sobre execuções de receitas;": "Nei riquadri sottostanti trovi informazioni dettagliate sulle esecuzioni delle ricette;",
    "equipment.Horário de pico;": "Orario di punta;",
    "equipment.Informações referentes a higienização;": "Informazioni relative alla pulizia;",
    "equipment.E histórico de eventos;": "E cronologia degli eventi;",
    "equipment.Lembre-se de que é necessário selecionar o período do qual deseja visualizar os dados. É possível fazer isso ao clicar sobre o calendário dos quadros e ao selecionar filtros.": "Ricorda che è necessario selezionare il periodo per il quale desideri visualizzare i dati. Puoi farlo cliccando sul calendario dei riquadri e selezionando i filtri.",
    "equipment.Baixando o arquivo... Ele estará disponível em breve!": "Download del file in corso... Sarà disponibile a breve!",
    "equipment.A contagem das horas de uso do magnetron são realizadas a partir da versão F1.1.0": "Il conteggio delle ore di utilizzo del magnetron viene effettuato a partire dalla versione F1.1.0",
    "equipment.Data de fabricação": "Data di produzione",
    "equipment.manutenção": "manutenzione",
    "equipment.Ao buscar e localizar um número de série, será aberto um canal temporário diretamente com o forno, permitindo o compartilhamento de seus dados de manutenção. Esses dados não serão armazenados na plataforma, sendo necessário realizar uma nova busca sempre que desejado.": "Quando cerchi e trovi un numero di serie, verrà aperto un canale temporaneo direttamente con il forno, consentendo la condivisione dei dati di manutenzione. Questi dati non saranno memorizzati sulla piattaforma e sarà necessario effettuare una nuova ricerca ogni volta che lo desideri.",
    "equipment.INFORME UM NÚMERO DE SÉRIE E CLIQUE EM BUSCAR": "INSERISCI UN NUMERO DI SERIE E CLICCA SU CERCA",
    "equipment.Apenas os modelos FIT Express / FIT Single Mag / FIT XL com a versão de software F2.1.0 enviarão dados de manutenção. As informações, principalmente as dos contadores, serão contabilizadas a partir dessa versão.": "Solo i modelli FIT Express / FIT Single Mag / FIT XL con la versione software F2.1.0 invieranno dati di manutenzione. Le informazioni, soprattutto quelle dei contatori, verranno registrate a partire da questa versione.",
    "equipment.Procurar número de série": "Cerca numero di serie",
    "equipment.ENCERRAR SESSÃO": "TERMINA SESSIONE",
    "equipment.Alerta": "Allarme",
    "equipment.Local": "Posizione",
    "equipment.Software": "Software",
    "equipment.Forno sem limpeza há": "Forno senza pulizia da",
    "equipment.Horário de pico": "Orario di punta",
    "equipment.HP": "OP",
    "equipment.RECIPE STARTED": "Ricetta avviata",
    "equipment.RECIPE CANCELED": "Ricetta annullata dall'utente",
    "equipment.RECIPE COMPLETED": "Ricetta completata con successo",
    "equipment.DOOR OPENED RECIPE": "Porta aperta durante la ricetta",
    "equipment.DOOR CLOSED RECIPE": "Porta chiusa durante la ricetta",
    "equipment.Receitas iniciadas": "Ricette avviate",
    "equipment.Receitas concluídas": "Ricette completate",
    "equipment.Receitas interrompidas": "Ricette interrotte",
    "equipment.Total de receitas concluídas:": "Totale ricette completate:",
    "equipment.TOTAL DE RECEITAS INTERROMPIDAS": "TOTALE RICETTE INTERROTTE",
    "equipment.DOWNLOAD_PROGRESS": "DOWNLOAD FILE IN CORSO... ATTENDERE, AVANZAMENTO: {progress}%",
    "equipment.Informe o número de série do forno": "Inserisci il numero di serie del forno",
    "equipment.preencha o número de série do forno": "Compila il numero di serie del forno",
    "equipment.NÚMERO DE SÉRIE NÃO CADASTRADO": "NUMERO DI SERIE NON REGISTRATO",
    "equipment.Número de série não encontrado. Por favor, verifique e tente novamente": "Numero di serie non trovato. Verifica e riprova",
    "equipment.Antes de iniciar a atualização, faça o backup das receitas salvas no equipamento para garantir a integridade dos dados. O backup pode ser feito via pen drive ou pela plataforma. Isso permite a recuperação das informações em caso de perda.": "Prima di avviare l'aggiornamento, esegui il backup delle ricette salvate sull'attrezzatura per garantire l'integrità dei dati. Il backup può essere effettuato tramite chiavetta USB o tramite la piattaforma. Questo consente il recupero delle informazioni in caso di perdita.",
    "equipment.MENU RECEIVED FROM THE PLATFORM BY FORCED METHOD": "Menu ricevuto dalla piattaforma tramite aggiornamento forzato",
    "equipment.Nome da receita não encontrado": "Nome della ricetta non trovato",
    "equipment.passos": "{count, plural, one {passaggio} other {passaggi}}",
    "equipment.minAbbreviation": "min",
    "equipment.secAbbreviation": "sec",
    "equipment.Configurações": "Configurazioni",
    "equipment.Tempo de preaquecimento": "Tempo di preriscaldamento",
    "equipment.Formato de data": "Formato data",
    "equipment.Formato de hora": "Formato ora",
    "equipment.Unidade de temperatura": "Unità di temperatura",
    "equipment.Aquecer/dourar mais": "Riscaldare/dorare di più",
    "equipment.Fabricante": "Produttore",
    "equipment.Voltagem": "Voltaggio",
    "equipment.Introdução": "Introduzione",
    "equipment.Modelo": "Modello",
    "equipment.Motor": "Motore",
    "equipment.Hostname": "Hostname",
    "equipment.STATUS DA OPERAÇÃO": "STATO DELL'OPERAZIONE",
    "equipment.ÚLTIMA LIMPEZA": "ULTIMA PULIZIA",
    "equipment.VELOCIDADE DO MOTOR": "VELOCITÀ DEL MOTORE",
    "equipment.TENSÃO ATUAL": "TENSIONE ATTUALE",
    "equipment.Sensores e periféricos": "Sensori e periferiche",
    "equipment.Contadores": "Contatori",
    "equipment.HORAS DE USO DO MOTOR": "ORE DI UTILIZZO DEL MOTORE",
    "equipment.HORAS DE USO DO MAGNETRON": "ORE DI UTILIZZO DEL MAGNETRON",
    "equipment.ABERTURAS DE PORTA": "APERTURE DELLA PORTA",
    "equipment.ATUAÇÃO DO RELE DA POWER": "ATTIVAZIONI DEL RELÈ POWER",
    "equipment.ATUAÇÃO DO SENSOR DE PORTA": "ATTIVAZIONI DEL SENSORE PORTA",
    "equipment.RECEITAS EXECUTADAS": "RICETTE ESEGUITE",
    "equipment.LIMPEZAS EXECUTADAS": "PULIZIE ESEGUITE",
    "equipment.HORAS DE USO DO FILTRO CATALÍTICO": "ORE DI UTILIZZO DEL FILTRO CATALITICO",
    "equipment.HORAS DE USO DO FILTRO DE AR": "ORE DI UTILIZZO DEL FILTRO DELL'ARIA",
    "equipment.CORRENTE DO MAGNETRON": "CORRENTE DEL MAGNETRON",
    "equipment.Erros": "Errori",
    "equipment.status online": "stato online",
    "equipment.status offline": "stato offline",
    "equipment.software accepted": "software accettato",
    "equipment.menu accepted": "menu accettato",
    "equipment.software pending": "software in sospeso",
    "equipment.menu pending": "menu in sospeso",
    "equipment.software refused": "software rifiutato",
    "equipment.menu refused": "menu rifiutato",
    "equipment.Ativado": "Attivato",
    "equipment.Desativado": "Disattivato",
    "equipment.Cozinhando": "In cottura",
    "equipment.Pré-aquecendo": "In preriscaldamento",
    "equipment.Em espera": "In attesa",
    "equipment.Limpando": "In pulizia",
    "equipment.horas": "ore",
    "equipment.Erro CAN": "Errore CAN",
    "equipment.Erro no sensor de câmara": "Errore del sensore della camera",
    "equipment.Alerta de temperatura alta no painel": "Allarme di alta temperatura del pannello",
    "equipment.Erro de temperatura alta no painel": "Errore di alta temperatura del pannello",
    "equipment.Alerta de comunicação no inversor de frequência": "Allarme di comunicazione dell'inverter di frequenza",
    "equipment.Alerta de status no inversor de frequência": "Allarme di stato dell'inverter di frequenza",
    "equipment.Alerta na corrente do magnetron": "Allarme sulla corrente del magnetron",
    "equipment.Erro no modelo do equipamento": "Errore nel modello dell'attrezzatura",
    "equipment.Erro no módulo de energia": "Errore nel modulo di alimentazione",
    "equipment.Erro I2C": "Errore I2C",
    "equipment.Erro de temperatura alta na placa": "Errore di alta temperatura della scheda",
    "equipment.Fechado": "Chiuso",
    "equipment.Aberto": "Aperto",
    "equipment.Câmara": "Camera",
    "equipment.Placa": "Scheda",
    "equipment.Tensão": "Tensione",
    "equipment.Corrente da placa": "Corrente della scheda",
    "equipment.Velocidade do motor": "Velocità del motore",
    "equipment.Rele da resistência": "Relè della resistenza",
    "equipment.Rele de curto circuito": "Relè di cortocircuito",
    "equipment.Ventilador radial": "Ventola radiale",
    "equipment.Led vermelho": "LED rosso",
    "equipment.Led verde": "LED verde",
    "equipment.Led azul": "LED blu",
    "equipment.Erro": "Errore",
    "equipment.Sensor": "Sensore",
    "equipment.Valor": "Valore",
    "equipment.Manutenção da temperatura": "Mantenimento della temperatura",
    "equipment.Manutenção": "Manutenzione",
    "equipment.Esfriando": "Raffreddamento in corso",
    "equipment.CEILING SENSOR ERROR": "Errore del sensore superiore",
    "equipment.BALLAST SENSOR ERROR": "Errore del sensore della platea",
    "equipment.VAPORIZER SENSOR ERROR": "Errore del sensore del vaporizzatore",
    "equipment.EQUIPMENT CONSUMPTION": "Consumo",
    "equipment.Sensores": "Sensori",
    "equipment.Falta de água": "Mancanza d'acqua",
    "equipment.Executando Receita": "Esecuzione ricetta",
    "equipment.Executando Limpeza": "Esecuzione pulizia",
    "equipment.Dia": "Giorno",
    "equipment.Semana": "Settimana",
    "equipment.Mês": "Mese",
    "equipment.Tempo": "Tempo",
    "equipment.Segunda": "Lunedì",
    "equipment.Terça": "Martedì",
    "equipment.Quarta": "Mercoledì",
    "equipment.Quinta": "Giovedì",
    "equipment.Sexta": "Venerdì",
    "equipment.Sábado": "Sabato",
    "equipment.Domingo": "Domenica",
    "equipment.CONSUMO ESTIMADO": "CONSUMO STIMATO",
    "equipment.CONSUMO ATUAL": "CONSUMO ATTUALE",
    "equipment.ECONOMIA COM MODO ECO": "RISPARMIO CON MODALITÀ ECO",
    "equipment.MÉDIA SEMANAL": "MEDIA SETTIMANALE",
    "equipment.MÉDIA MENSAL": "MEDIA MENSILE",
    "equipment.Consumo de energia": "Consumo energetico",
    "equipment.CONSUMO ACUMULADO": "CONSUMO ACCUMULATO",
    "equipment.MÉDIA DIÁRIA": "MEDIA GIORNALIERA",
    "equipment.mês selecionado": "mese selezionato",
    "equipment.Este valor representa a soma total dos consumos de cada hora do dia.": "Questo valore rappresenta la somma totale dei consumi di ogni ora del giorno.",
    "equipment.Este valor representa a soma total dos consumos de cada dia.": "Questo valore rappresenta la somma totale dei consumi di ogni giorno.",
    "equipment.Este valor representa a soma total dos consumos de cada semana.": "Questo valore rappresenta la somma totale dei consumi di ogni settimana.",
    "equipment.Este valor representa a soma total dos consumos de cada mês.": "Questo valore rappresenta la somma totale dei consumi di ogni mese.",
    "equipment.Este valor representa a média do consumo das horas, apresentando assim uma estimativa baseada em seu uso.": "Questo valore rappresenta il consumo medio orario, fornendo una stima basata sull'utilizzo.",
    "equipment.Este valor representa a média do consumo de cada dia, apresentando assim uma estimativa baseada em seu uso.": "Questo valore rappresenta il consumo medio giornaliero, fornendo una stima basata sull'utilizzo.",
    "equipment.Este valor representa a média do consumo semanal, apresentando assim uma estimativa baseada em seu uso.": "Questo valore rappresenta il consumo medio settimanale, fornendo una stima basata sull'utilizzo.",
    "equipment.Este valor representa a média do consumo dos últimos dois meses, apresentando assim uma estimativa baseada em seu uso.": "Questo valore rappresenta il consumo medio degli ultimi due mesi, fornendo una stima basata sull'utilizzo.",
    "equipment.Este valor representa a soma total da economia de consumo de cada hora do dia com a utilização do modo Eco.": "Questo valore rappresenta il risparmio totale dei consumi per ogni ora del giorno grazie alla modalità Eco.",
    "equipment.Este valor representa a soma total da economia de consumo de cada dia com a utilização do modo Eco.": "Questo valore rappresenta il risparmio totale dei consumi per ogni giorno grazie alla modalità Eco.",
    "equipment.Este valor representa a soma total da economia de consumo semanal com a utilização do modo Eco.": "Questo valore rappresenta il risparmio totale dei consumi settimanali grazie alla modalità Eco.",
    "equipment.Este valor representa a soma total da economia de consumo mensal com a utilização do modo Eco.": "Questo valore rappresenta il risparmio totale dei consumi mensili grazie alla modalità Eco.",
    "equipment.Este valor representa a média de consumo dos últimos 7 dias, desconsiderando o dia atual.": "Questo valore rappresenta il consumo medio degli ultimi 7 giorni, escluso il giorno corrente.",
    "equipment.Este valor representa a média de consumo das últimas 4 semanas.": "Questo valore rappresenta il consumo medio delle ultime 4 settimane.",
    "equipment.Este valor representa a média de consumo dos últimos 2 meses, desconsiderando o mês atual.": "Questo valore rappresenta il consumo medio degli ultimi 2 mesi, escluso il mese corrente.",
    "equipment.Lista de consumo de energia": "Elenco dei consumi energetici",
    "equipment.Período": "Periodo",
    "equipment.Consumo (kWh)": "Consumo (kWh)",
    "equipment.Economia com ECO (kWh)": "Risparmio con ECO (kWh)",
    "equipment.Total": "Totale",
    "equipment.Sensor de RI": "Sensore RI",
    "equipment.HUMIDITY SENSOR ERROR": "Errore del sensore di umidità",
    "equipment.TEMPERATURE SENSOR ERROR": "Errore del sensore di temperatura",
    "equipment.WATER FILTER CLEANING COMPLETED": "Sostituzione del filtro dell'acqua completata",
    "equipment.WATER FILTER CLEANING REJECTED": "Sostituzione del filtro dell'acqua rifiutata",
    "equipment.HOOD TURNED ON": "Cappa accesa",
    "equipment.HOOD TURNED OFF": "Cappa spenta",
    "equipment.AUTOMATIC PREHEATING REJECTED": "Preriscaldamento automatico rifiutato",
    "equipment.Receitas Forno": "Ricette del forno",
    "equipment.Receitas Fermentadora": "Ricette della camera di lievitazione",
    "equipment.média diária": "media giornaliera",
    "equipment.média de execução diária": "media giornaliera delle esecuzioni",
    "equipment.FERMENTADORA": "CAMERA DI LIEVITAZIONE",
    "equipment.FORNO": "FORNO",
    "equipment.DIA": "GIORNO",
    "equipment.Baixado": "Scaricato",
    "equipment.A limpeza diária do equipamento auxilia em seu bom funcionamento e impacta na garantia.": "La pulizia quotidiana dell'attrezzatura contribuisce al suo corretto funzionamento e influisce sulla garanzia.",
    "equipment.Desde a vinculação do equipamento ao IOK": "Dalla connessione dell'attrezzatura a IOK",
    "equipment.Total desde a vinculação do equipamento ao IOK": "Totale dalla connessione dell'attrezzatura a IOK",
    "equipment.Receitas do forno": "Ricette del forno",
    "equipment.Receitas da fermentadora": "Ricette della camera di lievitazione",
    "equipment.FERM.": "LIEV.",
    "equipment.Fermentadora": "Camera di lievitazione",
    "equipment.Coifa": "Cappa",
    "equipment.Preaquecimento automático": "Preriscaldamento automatico",
    "equipment.nivel": "livello",
    "equipment.Fermentadora ligada": "Camera di lievitazione accesa",
    "equipment.Fermentadora desligada": "Camera di lievitazione spenta",
    "equipment.Forno desligado": "Forno spento",
    "equipment.Equipamento ligado": "Attrezzatura accesa",
    "equipment.Equipamento desligado": "Attrezzatura spenta",
    "equipment.visualizar haccp": "visualizza HACCP",
    "equipment.HACCP": "HACCP",
    "equipment.Atualizar Equip.": "Aggiorna attrezzatura",
    "equipment.Consumo de agua por receita": "Consumo d'acqua per ricetta",
    "equipment.Consumo de energia por receita": "Consumo energetico per ricetta",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE AGUA POR RECEITA :(": "NON CI SONO ANCORA DATI SUL CONSUMO D'ACQUA PER RICETTA :(",
    "equipment.AINDA NAO HA DADOS DE CONSUMO DE ENERGIA POR RECEITA :(": "NON CI SONO ANCORA DATI SUL CONSUMO ENERGETICO PER RICETTA :(",
    "equipment.LITROS CONSUMIDOS NO DIA": "LITRI CONSUMATI NEL GIORNO",
    "equipment.ENERGIA CONSUMIDA NO DIA": "ENERGIA CONSUMATA NEL GIORNO",
    "equipment.CONSUMO ACUMULADO SEMANAL": "CONSUMO ACCUMULATO SETTIMANALE",
    "equipment.CONSUMO ACUMULADO MENSAL": "CONSUMO ACCUMULATO MENSILE",
    "equipment.Receitas": "Ricette",
    "equipment.Consumo (L)": "Consumo (L)",
    "equipment.Exec. dia - (L)": "Esec. giorno - (L)",
    "equipment.Exec. semana - (L)": "Esec. settimana - (L)",
    "equipment.Exec. mês - (L)": "Esec. mese - (L)",
    "equipment.Exec. dia - (kWh)": "Esec. giorno - (kWh)",
    "equipment.Exec. semana - (kWh)": "Esec. settimana - (kWh)",
    "equipment.Exec. mês - (kWh)": "Esec. mese - (kWh)",
    "equipment.Agua consumida (litros)": "Acqua consumata (litri)",
    "equipment.Energia consumida (kWh)": "Energia consumata (kWh)",
    "equipment.temperatura da câmara": "Temperatura della camera",
    "equipment.temperatura do vapor": "Temperatura del vapore",
    "equipment.último evento listado": "Ultimo evento elencato",
    "equipment.temperatura da sonda": "Temperatura della sonda",
    "equipment.porta": "Porta",
    "equipment.temperatura": "Temperatura",
    "equipment.temperatura atual": "Temperatura attuale",
    "equipment.média de oscilação diária": "Media dell'oscillazione giornaliera",
    "equipment.oscilação diária da temperatura": "Oscillazione giornaliera della temperatura",
    "equipment.temperature.sectionTitle": "Temperatura",
    "equipment.temperature.currentChamber": "TEMPERATURA ATTUALE DELLA CAMERA:",
    "equipment.temperature.currentProbe": "TEMPERATURA ATTUALE DELLA SONDA:",
    "equipment.temperature.currentSteam": "TEMPERATURA ATTUALE DEL VAPORE:",
    "equipment.temperature.dailyOscillation": "Oscillazione giornaliera della temperatura",
    "equipment.temperature.chamberShort": "Camera",
    "equipment.temperature.probeShort": "Sonda",
    "equipment.temperature.axisLabel": "Temperatura {unit}",
    "equipment.temperature.dailyAverage": "MEDIA GIORNALIERA",
    "equipment.temperature.weeklyAverage": "MEDIA SETTIMANALE",
    "equipment.temperature.monthlyAverage": "MEDIA MENSILE",
    "equipment.temperature.lastListedEvent": "Ultimo evento elencato",
    "equipment.temperature.door": "Porta",
    "equipment.temperature.open": "APERTA",
    "equipment.temperature.closed": "CHIUSA",
    "equipment.temperature.defineTimeRange": "Definisci intervallo di tempo:",
    "equipment.temperature.until": "alle",
    "equipment.cleaningType.smart": "Pulizia intelligente",
    "equipment.cleaningType.light": "Pulizia leggera",
    "equipment.cleaningType.medium": "Pulizia media",
    "equipment.cleaningType.heavy": "Pulizia intensiva",
    "equipment.cleaningType.decalcifying": "Pulizia decalcificante",
    "equipment.cleaningType.security": "Pulizia di sicurezza",
    "equipment.cleaningType.rinse": "Risciacquo",
    "equipment.cleaningType.custom": "Pulizia personalizzata",
    "equipment.cleaningTypeShort.smart": "Intelligente",
    "equipment.cleaningTypeShort.light": "Leggera",
    "equipment.cleaningTypeShort.medium": "Media",
    "equipment.cleaningTypeShort.heavy": "Intensiva",
    "equipment.cleaningTypeShort.decalcifying": "Decalcificante",
    "equipment.cleaningTypeShort.security": "Sicurezza",
    "equipment.cleaningTypeShort.rinse": "Risciacquo",
    "equipment.cleaningTypeShort.custom": "Personalizzata",
    "equipment.gerar gráficos": "genera grafici",
    "equipment.Realizada": "Eseguita",
    "equipment.Recomendada": "Consigliata",
    "equipment.Dias da semana": "Giorni della settimana",
    "equipment.Horário 24h": "Orario 24h",
    "equipment.seg": "Lun",
    "equipment.ter": "Mar",
    "equipment.qua": "Mer",
    "equipment.qui": "Gio",
    "equipment.sex": "Ven",
    "equipment.sab": "Sab",
    "equipment.dom": "Dom",
    "equipment.Desconhecido": "Sconosciuto",
    "equipment.AINDA NÃO HÁ DADOS DE CONSUMO DE ENERGIA AQUI :(": "NON CI SONO ANCORA DATI SUL CONSUMO ENERGETICO QUI :(",
    "equipment.monthShort.Jan": "Gen",
    "equipment.monthShort.Fev": "Feb",
    "equipment.monthShort.Mar": "Mar",
    "equipment.monthShort.Abr": "Apr",
    "equipment.monthShort.Mai": "Mag",
    "equipment.monthShort.Jun": "Giu",
    "equipment.monthShort.Jul": "Lug",
    "equipment.monthShort.Ago": "Ago",
    "equipment.monthShort.Set": "Set",
    "equipment.monthShort.Out": "Ott",
    "equipment.monthShort.Nov": "Nov",
    "equipment.monthShort.Dez": "Dic",
    "equipment.settingsChange.category": "Modifica dei parametri",
    "equipment.settingsChange.factoryTitle": "Modifica del parametro tecnico",
    "equipment.settingsChange.userTitle": "Modifica del parametro utente",
    "equipment.settingsChange.changedTo": "{label} modificato in {value}",
    "equipment.settingsChange.hardResetExecuted": "Hard reset eseguito",
    "equipment.settingsChange.userFactoryResetExecuted": "Ripristino delle impostazioni di fabbrica dell'utente eseguito",
    "equipment.settingsChange.magSensorEnabled": "sensore magnetron",
    "equipment.settingsChange.serialNumber": "numero di serie",
    "equipment.settingsChange.manufactureDate": "data di produzione",
    "equipment.settingsChange.inverterType": "tipo di inverter",
    "equipment.settingsChange.preHeatMotorSpeed": "velocità del motore di preriscaldamento",
    "equipment.settingsChange.voltage": "voltaggio",
    "equipment.settingsChange.oemModeEnabled": "modalità OEM",
    "equipment.settingsChange.controlDoor": "controllo porta",
    "equipment.settingsChange.hardReset": "hard reset",
    "equipment.settingsChange.preHeatTemperatureOne": "temperatura di preriscaldamento 1",
    "equipment.settingsChange.preHeatTemperatureTwo": "temperatura di preriscaldamento 2",
    "equipment.settingsChange.preHeatTime": "tempo di preriscaldamento",
    "equipment.settingsChange.preHeatTwoEnabled": "preriscaldamento 2",
    "equipment.settingsChange.userFactoryReset": "ripristino impostazioni di fabbrica utente",
    "equipment.settingsChange.enableManualMode": "modalità manuale",
    "equipment.settingsChange.enableFavorites": "preferiti",
    "equipment.settingsChange.enableHeatBrown": "riscalda/dora di più",
    "equipment.settingsChange.enableRepeatRecipe": "ripeti ricetta",
    "equipment.settingsChange.enableOperatorMode": "modalità operatore",
    "equipment.settingsChange.enableAutoImport": "importazione automatica",
    "equipment.settingsChange.enableRecipePreRunMessage": "messaggio prima della preparazione della ricetta",
    "equipment.settingsChange.controlDoorTwoInputs": "2 ingressi",
    "equipment.settingsChange.controlDoorThreeInputs": "3 ingressi",
    
    //LOJAS
    "store.Procurar loja": "Cerca negozio",
    "store.Excluir": "Elimina",
    "store.Editar": "Modifica",
    "store.nome": "Nome",
    "store.equipamentos": "Apparecchiature",
    "store.Equipamentos vinculados": "Attrezzature collegate",
    "store.cidade": "Città",
    "store.estado": "Stato",
    "store.salvar": "salva",
    "store.cadastrar loja": "registra negozio",
    "store.Nome fantasia": "Nome commerciale",
    "store.Preencha o nome da loja": "Inserisci il nome del negozio",
    "store.CNPJ": "Partita IVA/CNPJ",
    "store.Preencha o CNPJ da loja": "Inserisci il CNPJ del negozio",
    "store.CEP": "CAP",
    "store.Preencha o CEP da loja": "Inserisci il CAP del negozio",
    "store.Informe o nome fantasia": "Inserisci il nome commerciale",
    "store.Cidade": "Città",
    "store.Informe a cidade": "Inserisci la città",
    "store.Preencha a cidade": "Compila la città",
    "store.UF": "Provincia",
    "store.Preencha o UF da loja": "Inserisci la provincia del negozio",
    "store.Bairro": "Quartiere",
    "store.Informe o bairro": "Inserisci il quartiere",
    "store.Preencha o bairro da loja": "Compila il quartiere del negozio",
    "store.Endereço": "Indirizzo",
    "store.Informe o endereço": "Inserisci l'indirizzo",
    "store.Preencha o endereço da loja": "Compila l'indirizzo del negozio",
    "store.Nº": "N.",
    "store.Preencha o número": "Inserisci il numero",
    "store.Loja cadastrada com sucesso": "Negozio registrato con successo",
    "store.Erro ao adicionar loja. Tente novamente": "Errore durante l'aggiunta del negozio. Riprova",
    "store.Loja deletada com sucesso": "Negozio eliminato con successo",
    "store.Erro ao deletar loja. Tente novamente mais tarde": "Errore durante l'eliminazione del negozio. Riprova più tardi",
    "store.AINDA NÃO HÁ NENHUMA LOJA CADASTRADA :(": "NON CI SONO ANCORA NEGOZI REGISTRATI :(",
    "store.EXCLUIR LOJA": "ELIMINA NEGOZIO",
    "store.Você deseja excluir a loja da plataforma IOK?": "Desideri eliminare il negozio dalla piattaforma IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ela não terão vínculo com nenhuma loja, a menos que os vincule novamente.": "In questo modo, le apparecchiature associate non saranno più collegate ad alcun negozio, a meno che non vengano nuovamente associate.",
    "store.loja editada com sucesso": "Negozio modificato con successo",
    "store.não foi possível editar a loja. Tente novamente mais tarde": "Impossibile modificare il negozio. Riprova più tardi",
    "store.editar loja": "modifica negozio",
    "store.Procurar grupo de equipamentos": "Cerca gruppo di apparecchiature",
    "store.cadastrar grupo": "registra gruppo",
    "store.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "NON CI SONO ANCORA GRUPPI REGISTRATI :(",
    "store.description.AINDA NÃO HÁ NENHUM GRUPO CADASTRADO :(": "Fai clic sul pulsante nell'angolo superiore destro e aggiungi dei gruppi.",
    "store.cadastrar grupo de equipamentos": "registra gruppo di apparecchiature",
    "store.grupo de equipamentos cadastrado com sucesso!": "Gruppo di apparecchiature registrato con successo!",
    "store.não foi possível cadastrar o grupo. Tente novamente mais tarde": "Impossibile registrare il gruppo. Riprova più tardi",
    "store.Nome do grupo": "Nome del gruppo",
    "store.informe o nome do grupo": "Inserisci il nome del gruppo",
    "store.preencha o nome do grupo": "Compila il nome del gruppo",
    "store.Grupo de equipamentos deletado com sucesso!": "Gruppo di apparecchiature eliminato con successo!",
    "store.Erro ao deletar o grupo. Tente novamente mais tarde": "Errore durante l'eliminazione del gruppo. Riprova più tardi",
    "store.EXCLUIR GRUPO DE EQUIPAMENTOS": "ELIMINA GRUPPO DI APPARECCHIATURE",
    "store.Você deseja excluir este grupo de equipamentos da plataforma IOK?": "Desideri eliminare questo gruppo di apparecchiature dalla piattaforma IOK?",
    "store.Ao fazer isso, os equipamentos atrelados à ele não terão vínculo com nenhum grupo, a menos que os vincule novamente.": "In questo modo, le apparecchiature associate non saranno più collegate ad alcun gruppo, a meno che non vengano nuovamente associate.",
    "store.grupo de equipamentos editado com sucesso!": "Gruppo di apparecchiature modificato con successo!",
    "store.não foi possível editar o grupo. Tente novamente mais tarde": "Impossibile modificare il gruppo. Riprova più tardi",
    "store.editar grupo de equipamentos": "modifica gruppo di apparecchiature",
    "store.CEP não encontrado no Brasil": "CAP non trovato in Brasile",
    "store.Cadastrar": "Registrati",
    "store.Equipamentos vinculados": "Attrezzature collegate",
    
    // NAVBAR
    "navbar.home": "home",
    "navbar.cookbook": "cookbook",
    "navbar.my menus": "i miei menu",
    "navbar.equipment": "apparecchiature",
    "navbar.users": "utenti",
    "navbar.calls": "assistenza",
    "navbar.settings": "impostazioni",
    "navbar.help": "aiuto",
    "navbar.logout": "Esci",
    "navbar.Editar conta": "Modifica account",
    "navbar.API Externa": "API Esterna",
    "navbar.companhias": "aziende",
    "navbar.information": "informazioni IOK",
    
    // FOOTERBAR
    "footerBar.menu": "Menu",
    "footerBar.cookbook": "Cookbook",
    "footerBar.home": "Home",
    "footerBar.menus": "Menu",
    "footerBar.notifications": "Notifiche",
    
    //MAP
    "map.título": "Posizione",
    "map.erro": "errore!",
    "map.mensagem de erro": "impossibile caricare la mappa.",
    "map.Localização não disponível": "Posizione non disponibile",
    
    //MODAL
    "modal.CONFIRMAR": "CONFERMA",
    "modal.Salvar alterações": "Salva modifiche",
    "Modal.Há alterações não salvas nos parâmetros dos passos ":
    "Sono presenti modifiche non salvate nei parametri dei passaggi ",
    "Modal.Como deseja proceder?": "Come desideri procedere?",
    "Modal.Avaliar alterações realizadas": "Rivedi le modifiche apportate",
    "Modal.Descartar alterações": "Scarta le modifiche",
    
    //USUÁRIOS
    "user.Nome": "Nome",
    "user.E-mail": "E-mail",
    "user.Permissão": "Permesso",
    "user.Loja": "Negozio",
    "user.Status": "Stato",
    "user.Excluir": "Elimina",
    "user.Editar": "Modifica",
    "user.Procurar usuário": "Cerca utente",
    "user.ADICIONAR USUÁRIO": "AGGIUNGI UTENTE",
    "user.AINDA NÃO HÁ NENHUM USUÁRIO CADASTRADO :(": "NON CI SONO ANCORA UTENTI REGISTRATI :(",
    "user.+ Usuário": "+ Utente",
    "user.Informe o nome do usuário": "Inserisci il nome dell'utente",
    "user.Preencha o nome do usuário": "Compila il nome dell'utente",
    "user.Informe o e-mail do usuário": "Inserisci l'e-mail dell'utente",
    "user.Preencha com um e-mail válido": "Inserisci un'e-mail valida",
    "user.Administrador": "Amministratore",
    "user.Usuário": "Utente",
    "user.Preencha o telefone do usuário": "Compila il numero di telefono dell'utente",
    "user.Selecione a permissão do usuário": "Seleziona il permesso dell'utente",
    "user.Ativo": "Attivo",
    "user.Inativo": "Inattivo",
    "user.Usuário deletado da plataforma com sucesso!": "Utente eliminato dalla piattaforma con successo!",
    "user.Ocorreu um erro. Tente novamente mais tarde": "Si è verificato un errore. Riprova più tardi",
    "user.EXCLUIR USUÁRIO": "ELIMINA UTENTE",
    "user.delete.paragrafo 1": "Desideri eliminare l'utente dalla piattaforma IOK?",
    "user.delete.paragrafo 2": "In questo modo perderà l'accesso a tutti gli strumenti della piattaforma, a meno che non venga aggiunto nuovamente seguendo le istruzioni di registrazione.",
    "user.EDITAR USUÁRIO": "MODIFICA UTENTE",
    "user.Usuário editado com sucesso!": "Utente modificato con successo!",
    "user.Não foi possível editar este usuário. Por favor, tente mais tarde": "Non è stato possibile modificare questo utente. Riprova più tardi",
    "user.INFORMAÇÕES DO USUÁRIO": "INFORMAZIONI UTENTE",
    "user.Telefone": "Telefono",
    "user.Não foi possível cadastrar este usuário. Por favor, tente mais tarde": "Non è stato possibile registrare questo utente. Riprova più tardi",
    "user.Usuário adicionado com sucesso!": "Utente aggiunto con successo!",
    "user.CRIAR TIPO DE USUÁRIO": "CREA TIPO DI UTENTE",
    "user.Criar novo tipo de usuário": "Crea un nuovo tipo di utente",
    "user.Adicionar novo usuário": "Aggiungi nuovo utente",
    "user.Permissões": "Permessi",
    "user.Preencha o nome do novo tipo de usuário": "Compila il nome del nuovo tipo di utente",
    "user.Selecione pelo menos uma permissão": "Seleziona almeno un permesso",
    "user.Não foi possível carregar as permissões": "Impossibile caricare i permessi",
    "user.Tipo de usuário criado com sucesso!": "Tipo di utente creato con successo!",
    "user.Não foi possível criar este novo tipo de usuário. Por favor, tente mais tarde": "Non è stato possibile creare questo nuovo tipo di utente. Riprova più tardi",
    "user.Não foi possível carregar os tipos de usuário da companhia": "Impossibile caricare i tipi di utente dell'azienda",
    "user.Tipo de usuário": "Tipo di utente",
    "user.E-mail já cadastrado na plataforma. Informe um novo e-mail": "E-mail già registrata sulla piattaforma. Inserisci una nuova e-mail",
    "user.UNIR CONTAS": "UNISCI ACCOUNT",
    "user.ID da companhia": "ID dell'azienda",
    "user.Digite o ID da companhia que deseja unir a sua conta": "Inserisci l'ID dell'azienda che desideri unire al tuo account",
    "user.Preencha o ID da companhia": "Compila l'ID dell'azienda",
    "user.O administrador da outra conta poderá localizar o ID ao clicar em seu nome de usuário, localizado no menu superior, no canto direito da tela.": "L'amministratore dell'altro account può trovare l'ID cliccando sul proprio nome utente nel menu superiore, nell'angolo destro dello schermo.",
    "user.O administrador da outra conta receberá um e-mail para aceitar sua solicitação. Assim que for aceita, a união das duas contas será realizada!": "L'amministratore dell'altro account riceverà un'e-mail per accettare la tua richiesta. Una volta accettata, l'unione dei due account verrà effettuata!",
    "user.Não foi possível solicitar a união de contas. Por favor, confirme o ID ou tente mais tarde": "Non è stato possibile richiedere l'unione degli account. Verifica l'ID o riprova più tardi",
    "user.SOLICITAÇÃO APROVADA COM SUCESSO": "RICHIESTA APPROVATA CON SUCCESSO",
    "user.AGUARDE ENQUANTO REALIZAMOS A UNIÃO DAS CONTAS. ESTE PROCESSO PODE LEVAR ALGUNS MINUTOS...": "ATTENDI MENTRE ESEGUIAMO L'UNIONE DEGLI ACCOUNT. QUESTO PROCESSO POTREBBE RICHIEDERE ALCUNI MINUTI...",
    "user.UNIÃO DE CONTAS FINALIZADA COM SUCESSO! CLIQUE NO BOTÃO ABAIXO PARA ACESSAR A PLATAFORMA.": "UNIONE DEGLI ACCOUNT COMPLETATA CON SUCCESSO! CLICCA SUL PULSANTE QUI SOTTO PER ACCEDERE ALLA PIATTAFORMA.",
    "user.NÃO CONSEGUIMOS REALIZAR A UNIÃO DAS CONTAS. POR FAVOR, TENTE NOVAMENTE. SE O PROBLEMA PERSISTIR, ENTRE EM CONTATO COM NOSSO SUPORTE.": "NON SIAMO RIUSCITI A COMPLETARE L'UNIONE DEGLI ACCOUNT. RIPROVA. SE IL PROBLEMA PERSISTE, CONTATTA IL NOSTRO SUPPORTO.",
    "user.possui todos os acessos": "ha tutti gli accessi",
    "user.possui o acesso das abas cookbook, meus menus e equipamentos": "ha accesso alle schede Cookbook, I miei menu e Attrezzature",
    "user.possui apenas o acesso da aba cookbook": "ha accesso solo alla scheda Cookbook",
    "user.possui apenas o acesso da aba equipamentos": "ha accesso solo alla scheda Attrezzature",
    "user.possui apenas o acesso da aba meus menus": "ha accesso solo alla scheda I miei menu",
    "user.Grupo de equipamentos": "Gruppo di attrezzature",
    "user.Informe o telefone do usuário": "Inserisci il numero di telefono dell'utente",
    "user.Nenhum grupo criado": "Nessun gruppo creato",
    "user.Digite o ID da companhia que terá acesso à sua conta": "Inserisci l'ID dell'azienda che avrà accesso al tuo account",
    "user.Ao informar um ID para unir contas com sua companhia, esteja ciente de que o novo usuário também se tornará Administrador da conta de sua companhia. É importante informar que a partir do momento em que um usuário aceitar unir contas com sua companhia, a companhia pertencente a ele deixará de existir.":
    "Inserendo un ID per unire account con la tua azienda, tieni presente che il nuovo utente diventerà anche Amministratore dell'account della tua azienda. È importante sapere che, dal momento in cui un utente accetta di unire gli account con la tua azienda, l'azienda a lui associata cesserà di esistere.",
    "user.Exemplo: Sua conta: 001 | Outra conta: 111. Depois de unir contas com você, a outra conta passará a ser 001.": "Esempio: Il tuo account: 001 | Altro account: 111. Dopo l'unione con il tuo account, l'altro account diventerà 001.",
    "user.Tela de Equipamentos": "Schermata Attrezzature",
    "user.Tela de Meus Menus": "Schermata I miei menu",
    "user.Tela do Cookbook": "Schermata Cookbook",
    "user.Tela de Usuários": "Schermata Utenti",
    "user.Aba de Suporte": "Scheda Supporto",
    "user.Usuário Comum": "Utente standard",
    "user.Usuário do Cookbook": "Utente Cookbook",
    "user.Usuário de Equipamentos": "Utente Attrezzature",
    "user.Usuário de Meus Menus": "Utente I miei menu",
    "user.Você deseja excluir seu acesso da plataforma IOK?": "Desideri eliminare il tuo accesso alla piattaforma IOK?",
    "user.Ao fazer isso, você perderá o acesso a todas as ferramentas da plataforma e, para voltar a acessá-la, será necessário ser adicionado à ela novamente.": "In questo modo perderai l'accesso a tutti gli strumenti della piattaforma e, per accedervi nuovamente, dovrai essere aggiunto di nuovo.",
    "user.CONFIRMAÇÃO": "CONFERMA",
    "user.Confirme sua senha": "Conferma la tua password",
    "user.Senha incorreta": "Password errata",
    "user.Os equipamentos e menus criados por ele serão transferidos para o seu nome.": "Le attrezzature e i menu creati da lui saranno trasferiti a tuo nome.",
    
    //TUTORIAIS 
    "tutorial.Fechar": "Chiudi",
    "tutorial.Fim": "Fine",
    "tutorial.Próximo": "Avanti",
    "tutorial.Abrir": "Apri",
    "tutorial.Pular tutorial": "Salta tutorial",
    "tutorial.Editar detalhes da receita": "Modifica dettagli della ricetta",
    "tutorial.Agora você pode adicionar mais detalhes às suas receitas e deixá-las ainda mais completas. Clique em Editar detalhes e preencha as informações necessárias.": "Ora puoi aggiungere ulteriori dettagli alle tue ricette e renderle ancora più complete. Fai clic su Modifica dettagli e compila le informazioni necessarie.",
    "tutorial.Salvar edição da receita": "Salva modifica della ricetta",
    "tutorial.Depois de informar mais detalhes da receita, clique em Salvar.": "Dopo aver inserito ulteriori dettagli della ricetta, fai clic su Salva.",
    "tutorial.Editar registro de um equipamento": "Modifica registrazione di un'apparecchiatura",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Categoria e Loja.": "Per completare la registrazione delle tue apparecchiature, apri il menu laterale, fai clic su Modifica e compila le informazioni relative a Categoria e Negozio.",
    "tutorial.Editar usuário": "Modifica utente",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente a Loja a qual ele faz parte.": "Per completare la registrazione degli utenti, apri il menu laterale, fai clic su Modifica e inserisci le informazioni relative al Negozio di appartenenza.",
    "tutorial.Salvar edições de um equipamento": "Salva modifiche dell'apparecchiatura",
    "tutorial.Depois de completar o registro de seus equipamentos, clique em Salvar.": "Dopo aver completato la registrazione delle tue apparecchiature, fai clic su Salva.",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em uma loja, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Facendo clic sulla riga di un'apparecchiatura registrata in un negozio, puoi visualizzare ulteriori statistiche e informazioni, oltre a richiedere assistenza o inviare aggiornamenti.",
    "tutorial.Para visualizar mais informações sobre a loja, como localização e receitas mais preparadas, clique sobre a linha da unidade que deseja analisar.": "Per visualizzare maggiori informazioni sul negozio, come la posizione e le ricette più eseguite, fai clic sulla riga dell'unità che desideri analizzare.",
    "tutorial.Criar receita": "Crea ricetta",
    "tutorial.No cookbook você pode criar suas próprias receitas! Clique em Criar Receita e preencha todas as informações necessárias.": "Nel Cookbook puoi creare le tue ricette! Fai clic su Crea ricetta e compila tutte le informazioni necessarie.",
    "tutorial.Editar ou excluir um usuário": "Modifica o elimina un utente",
    "tutorial.Para excluir ou editar as informações de um usuário já cadastrado, clique no menu lateral e selecione a opção desejada.": "Per eliminare o modificare le informazioni di un utente già registrato, fai clic sul menu laterale e seleziona l'opzione desiderata.",
    "tutorial.Gerenciamento de usuários": "Gestione utenti",
    "tutorial.Aqui você pode gerenciar seus usuários com mais facilidade. Ao clicar em + Usuário, você poderá adicionar um novo usuário ou criar um novo tipo de usuário.": "Qui puoi gestire i tuoi utenti più facilmente. Facendo clic su + Utente, potrai aggiungere un nuovo utente o creare un nuovo tipo di utente.",
    "tutorial.Suas receitas": "Le tue ricette",
    "tutorial.Pelo cookbook você também encontra suas próprias receitas, além de poder criá-las! Clique em Receitas Salvas para visualizar as receitas que foram salvas do cookbook da Prática e também as criadas por você.": "Nel Cookbook puoi anche trovare le tue ricette, oltre a crearne di nuove! Fai clic su Ricette salvate per visualizzare le ricette salvate dal Cookbook di Prática e quelle create da te.",
    "tutorial.Filtros do Cookbook": "Filtri del Cookbook",
    "tutorial.Para facilitar a navegação pelas receitas, você pode aplicar filtros a elas. Basta clicar no filtro desejado e escolher uma de suas opções.": "Per facilitare la navigazione tra le ricette, puoi applicare dei filtri. Basta fare clic sul filtro desiderato e scegliere una delle opzioni disponibili.",
    "tutorial.Cookbook": "Cookbook",
    "tutorial.No cookbook, em Receitas Disponíveis, você encontrará as receitas criadas pelos Chefs da Prática e poderá utilizá-las sempre que quiser.": "Nel Cookbook, nella sezione Ricette disponibili, troverai le ricette create dagli Chef di Prática e potrai utilizzarle ogni volta che desideri.",
    "tutorial.Atualizar equipamentos": "Aggiorna apparecchiature",
    "tutorial.Para enviar uma atualização a seus equipamentos, clique em Atualizar Equipamentos, selecione os modelos que deseja atualizar e a forma como deseja realizar essa atualização - via wi-fi ou pen drive. Depois disso, clique em Confirmar.": "Per inviare un aggiornamento alle tue apparecchiature, fai clic su Aggiorna apparecchiature, seleziona i modelli da aggiornare e il metodo di aggiornamento (tramite Wi-Fi o chiavetta USB). Successivamente, fai clic su Conferma.",
    "tutorial.Adicionar equipamento": "Aggiungi apparecchiatura",
    "tutorial.Para adicionar um equipamento à sua conta, clique em Adicionar Equipamento e preencha as informações do modal. Depois disso, clique em Salvar.": "Per aggiungere un'apparecchiatura al tuo account, fai clic su Aggiungi apparecchiatura e compila le informazioni nella finestra. Successivamente, fai clic su Salva.",
    "tutorial.Editar equipamento": "Modifica apparecchiatura",
    "tutorial.Para desvincular um equipamento ou editar suas informações, clique no menu lateral e selecione a opção desejada.": "Per scollegare un'apparecchiatura o modificarne le informazioni, fai clic sul menu laterale e seleziona l'opzione desiderata.",
    "tutorial.Seus equipamentos": "Le tue apparecchiature",
    "tutorial.Aqui você visualizará todos os equipamentos cadastrados em sua plataforma.": "Qui visualizzerai tutte le apparecchiature registrate sulla tua piattaforma.",
    "tutorial.Restaurar arquivos": "Ripristina file",
    "tutorial.Para restaurar um arquivo excluído ou deletá-lo permanentemente, clique no menu lateral e selecione a opção desejada.": "Per ripristinare un file eliminato o cancellarlo definitivamente, fai clic sul menu laterale e seleziona l'opzione desiderata.",
    "tutorial.Lixeira": "Cestino",
    "tutorial.Os menus excluídos serão mantidos na Lixeira por 30 dias. Depois desse prazo serão excluídos permanentemente.": "I menu eliminati saranno conservati nel Cestino per 30 giorni. Dopo tale periodo verranno eliminati definitivamente.",
    "tutorial.Salvar edições de usuário": "Salva modifiche dell'utente",
    "tutorial.Depois de completar o cadastro dos usuários, clique em Salvar.": "Dopo aver completato la registrazione degli utenti, fai clic su Salva.",
    "tutorial.Criar menu": "Crea menu",
    "tutorial.Para criar e personalizar um menu, clique em Criar Menu e preencha as informações necessárias no modal. Você pode editar um menu a qualquer momento.": "Per creare e personalizzare un menu, fai clic su Crea menu e compila le informazioni necessarie nella finestra. Puoi modificare un menu in qualsiasi momento.",
    "tutorial.Importar menu": "Importa menu",
    "tutorial.Para importar um menu, clique em Importar Menu e selecione o modelo e versão do equipamento.": "Per importare un menu, fai clic su Importa menu e seleziona il modello e la versione dell'apparecchiatura.",
    "tutorial.Criar grupo": "Crea gruppo",
    "tutorial.Para organizar suas receitas em grupos, clique em Criar Grupo e preencha as informações necessárias no modal.": "Per organizzare le tue ricette in gruppi, fai clic su Crea gruppo e compila le informazioni necessarie nella finestra.",
    "tutorial.Tipos de usuário": "Tipi di utente",
    "tutorial.Agora você também pode criar tipos de usuários com permissões específicas para atender melhor a sua organização.": "Ora puoi anche creare tipi di utente con autorizzazioni specifiche per soddisfare al meglio le esigenze della tua organizzazione.",
    "tutorial.Gerenciamento de contas": "Gestione degli account",
    "tutorial.Se caso outra pessoa da sua organização também migrou a conta principal da empresa, aqui você pode unir as duas contas.": "Se un'altra persona della tua organizzazione ha anch'essa migrato l'account principale dell'azienda, qui puoi unire i due account.",
    "tutorial.Para completar o registro de seus equipamentos, abra o menu lateral, clique em Editar e preencha as informações de Grupo.": "Per completare la registrazione delle tue apparecchiature, apri il menu laterale, fai clic su Modifica e compila le informazioni del Gruppo.",
    "tutorial.Para completar o cadastro dos usuários, abra o menu lateral, clique em Editar e preencha a informação referente ao Grupo de equipamentos a qual ele faz parte.": "Per completare la registrazione degli utenti, apri il menu laterale, fai clic su Modifica e inserisci le informazioni relative al gruppo di apparecchiature di appartenenza.",
    "tutorial.Grupos de equipamentos": "Gruppi di apparecchiature",
    "tutorial.Na aba Grupos você pode visualizar os grupos cadastrados e os equipamentos distribuídos entre eles. Além disso, é possível cadastrar novos grupos e editar os já cadastrados.": "Nella scheda Gruppi puoi visualizzare i gruppi registrati e le apparecchiature distribuite tra di essi. Inoltre, è possibile creare nuovi gruppi e modificare quelli esistenti.",
    "tutorial.Detalhes de grupos": "Dettagli dei gruppi",
    "tutorial.Para visualizar mais informações sobre o grupo, como localização e receitas mais preparadas, clique sobre a linha que deseja analisar.": "Per visualizzare maggiori informazioni sul gruppo, come la posizione e le ricette più eseguite, fai clic sulla riga che desideri analizzare.",
    "tutorial.Equipamentos em grupos": "Apparecchiature nei gruppi",
    "tutorial.Ao clicar sobre a linha de um equipamento cadastrado em um grupo, você pode visualizar mais estatísticas e informações sobre ele, além de poder solicitar um atendimento ou disparar atualizações.": "Facendo clic sulla riga di un'apparecchiatura registrata in un gruppo, puoi visualizzare ulteriori statistiche e informazioni, oltre a richiedere assistenza o inviare aggiornamenti.",
    "tutorial.Grupos": "Gruppi",
    "tutorial.Atualização e cache": "Aggiornamento e cache",
    "tutorial.Para atualizar a plataforma e corrigir eventuais problemas de cache, clique aqui.": "Per aggiornare la piattaforma e correggere eventuali problemi di cache, fai clic qui.",
    "tutorial.Dados dos equipamentos": "Dati delle apparecchiature",
    "tutorial.Ao clicar sobre a linha de um equipamento, você pode visualizar mais estatísticas e informações sobre ele, como as receitas mais preparadas, limpezas realizadas e outros dados relevantes.": "Facendo clic sulla riga di un'apparecchiatura, puoi visualizzare ulteriori statistiche e informazioni, come le ricette più eseguite, le pulizie effettuate e altri dati rilevanti.",
    "tutorial.Para alterar o idioma de sua plataforma, clique em Idioma e selecione a linguagem desejada.": "Per modificare la lingua della piattaforma, fai clic su Lingua e seleziona quella desiderata.",
    "tutorial.Alterar idioma": "Cambia lingua",
    "tutorial.Para editar ou configurar sua conta, clique em seu nome e selecione a opção desejada.": "Per modificare o configurare il tuo account, fai clic sul tuo nome e seleziona l'opzione desiderata.",
    "tutorial.Editar conta": "Modifica account",
    "tutorial.Total de Usuários Cadastrados em sua conta.": "Numero totale di utenti registrati nel tuo account.",
    "tutorial.Home": "Home",
    "tutorial.Localização de seus equipamentos, sendo possível expandir o mapa para melhor visualização;": "Posizione delle tue apparecchiature, con la possibilità di espandere la mappa per una migliore visualizzazione;",
    "tutorial.Atualizações referentes a versão dos equipamentos vinculados a sua conta;": "Aggiornamenti relativi alla versione delle apparecchiature collegate al tuo account;",
    "tutorial.Total de Receitas Cadastradas;": "Totale delle ricette registrate;",
    "tutorial.Menus Disponíveis;": "Menu disponibili;",
    "tutorial.Esta é a sua home! Aqui você encontra um resumo geral sobre sua conta;" : "Questa è la tua home page! Qui trovi una panoramica generale del tuo account;",
    "tutorial.Clique nas abas do menu para explorar a plataforma e conhecer tudo o que ela pode oferecer.": "Fai clic sulle schede del menu per esplorare la piattaforma e scoprire tutto ciò che può offrirti.",
    "tutorial.Exportar menu": "Esporta menu",
    "tutorial.Depois de personalizar seu menu, exporte-o para seus equipamentos pela internet ou por chiavetta USB.": "Dopo aver personalizzato il tuo menu, esportalo alle tue apparecchiature tramite Internet o chiavetta USB.",
    "tutorial.Na aba Localização você pode visualizar os endereços já cadastrados, além de criar localizações precisas para vincular seus equipamentos a elas.": "Nella scheda Posizione puoi visualizzare gli indirizzi già registrati, oltre a creare posizioni precise a cui collegare le tue apparecchiature.",
    "tutorial.Localização": "Posizione",
    "tutorial.Informações sobre o equipamento": "Informazioni sull'apparecchiatura",
    "tutorial.Equipamentos Ligados e quantos estão enviando dados de uso;" : "Dispositivi connessi e quanti stanno inviando dati di utilizzo;",
    
    //RECOVER ACCOUNT
    "recoverAccount.Para prosseguir, selecione a categoria na qual você se encaixa:": "Per procedere, seleziona la categoria a cui appartieni:",
    "recoverAccount.Deseja acessar a plataforma como DISTRIBUIDOR? Crie sua conta clicando em EMPRESA e entre em contato conosco para liberarmos os demais acessos.": "Desideri accedere alla piattaforma come DISTRIBUTORE? Crea il tuo account cliccando su AZIENDA e contattaci per abilitare gli altri accessi.",
    "recoverAccount.A qual organização você pertence": "A quale organizzazione appartieni?",
    
    //RECOVER PASSWORD PAGE
    "recoverPassword.E-mail para recuperação de senha":
    "E-mail per il recupero della password",
    "recoverPassword.Informe o e-mail cadastrado na plataforma":
    "Inserisci l'e-mail registrata sulla piattaforma",
    "recoverPassword.E-mail inválido. Por favor, verifique":
    "E-mail non valida. Per favore, verifica",
    "recoverPassword.RECUPERAR SENHA":
    "RECUPERA PASSWORD",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL COM O LINK DE RECUPERAÇÃO DE SENHA":
    "A BREVE RICEVERAI UN'E-MAIL CON IL LINK PER IL RECUPERO DELLA PASSWORD",
    "recoverPassword.Informe seu e-mail":
    "Inserisci la tua e-mail",
    "recoverPassword.Crie uma nova senha":
    "Crea una nuova password",
    "recoverPassword.O campo senha deve conter no mínimo 6 caracteres":
    "Il campo password deve contenere almeno 6 caratteri",
    "recoverPassword.Confirme sua senha":
    "Conferma la tua password",
    "recoverPassword.As senhas devem ser iguais":
    "Le password devono essere uguali",
    "recoverPassword.ENTRAR":
    "ACCEDI",
    "recoverPassword.EM BREVE VOCÊ RECEBERÁ UM E-MAIL PARA CONFIRMAR SUA IDENTIDADE":
    "A BREVE RICEVERAI UN'E-MAIL PER CONFERMARE LA TUA IDENTITÀ",
    "recoverPassword.CONTINUAR":
    "CONTINUA",
    "recoverPassword.CONFIRMAR":
    "CONFERMA",
    "recoverPassword.Por segurança, o acesso à conta foi bloqueado devido a tentativas de login incorretas.":
    "Per motivi di sicurezza, l'accesso all'account è stato bloccato a causa di tentativi di accesso non corretti.",
    "recoverPassword.Para desbloquear sua conta, siga as instruções após clicar no botão abaixo:":
    "Per sbloccare il tuo account, segui le istruzioni dopo aver cliccato sul pulsante qui sotto:",
    "recoverPassword.Desbloquear conta":
    "Sblocca account",
    "recoverPassword.Você recebeu um e-mail para iniciar o desbloqueio de sua conta.":
    "Hai ricevuto un'e-mail per avviare lo sblocco del tuo account.",
    "recoverPassword.Verifique sua caixa de entrada ou spam.":
    "Controlla la tua posta in arrivo o la cartella spam.",
    "recoverPassword.Verifique seu e-mail":
    "Controlla la tua e-mail",
    "recoverPassword.Informe seu e-mail de login e crie uma nova senha para acessar sua conta.":
    "Inserisci la tua e-mail di accesso e crea una nuova password per accedere al tuo account.",
    
    // EXPORT
    "export.Limpezas": "Pulizie",
    "export.Eventos": "Eventi",
    "export.Lista de receitas preparadas": "Elenco delle ricette eseguite",
    "export.Lista de limpezas realizadas": "Elenco delle pulizie eseguite",
    "export.Lista de eventos ocorridos": "Elenco degli eventi verificatisi",
    "export.Exportar dados": "Esporta dati",
    "export.Exportar": "Esporta",
    "export.Informações do equipamento": "Informazioni sull'attrezzatura",
    "export.Dados exportados com sucesso!": "Dati esportati con successo!",
    "export.Não foi possível exportar os dados. Por favor, tente novamente mais tarde.": "Non è stato possibile esportare i dati. Per favore, riprova più tardi.",
    "export.Detalhes do menu": "Dettagli del menu",
    "export.Detalhes de receitas": "Dettagli delle ricette",
    "export.Detalhes e Passos": "Dettagli e passaggi",
    "export.Exportando dados. Em breve o arquivo estará disponível!": "Esportazione dei dati in corso. Il file sarà disponibile a breve!",
    "export.Resumo dos passos": "Riepilogo dei passaggi",
    "export.salvar imagem": "salva immagine",
    "export.Nenhum modelo foi selecionado": "Nessun modello selezionato",
    
    // COMPANIES PAGE
    "company.Procurar companhia": "Cerca azienda",
    "company.Adicionar companhia": "Aggiungi azienda",
    "company.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "NON CI SONO ANCORA AZIENDE REGISTRATE :(",
    "company.description.AINDA NÃO HÁ COMPANHIAS CADASTRADAS :(": "Fai clic sul pulsante nell'angolo in alto a destra e aggiungi aziende.",
    "company.Adicionar": "Aggiungi",
    "company.ADICIONAR EQUIPAMENTOS": "AGGIUNGI ATTREZZATURE",
    "company.Preencha pelo menos um número de série": "Inserisci almeno un numero di serie",
    "company.Informe os números de série": "Inserisci i numeri di serie",
    "company.Número de série": "Numero di serie",
    "company.Para incluir vários equipamentos, separe-os com ponto e vírgula (;).": "Per includere più attrezzature, separale con un punto e virgola (;).",
    "company.Informe o número de série do equipamento que deseja adicionar abaixo.": "Inserisci qui sotto il numero di serie dell'attrezzatura che desideri aggiungere.",
    "company.Números de série adicionados com sucesso!": "Numeri di serie aggiunti con successo!",
    "company.Não foi possível adicionar os números de série. Tente novamente mais tarde": "Non è stato possibile aggiungere i numeri di serie. Riprova più tardi",
    "company.adicionar": "aggiungi",
    "company.Procurar por companhia ou ID": "Cerca per azienda o ID",
    "company.Companhia": "Azienda",
    "company.E-mail principal": "E-mail principale",
    "company.Local": "Località",
    "company.Companhia adicionada com sucesso!": "Azienda aggiunta con successo!",
    "company.Não foi possível cadastrar a companhia": "Non è stato possibile registrare l'azienda",
    "company.REMOVER COMPANHIA": "RIMUOVI AZIENDA",
    "company.Você deseja remover a companhia definitivamente? Os equipamentos vinculados a ela também serão removidos de sua conta.": "Desideri rimuovere definitivamente l'azienda? Anche le attrezzature collegate ad essa saranno rimosse dal tuo account.",
    "company.Esta ação não poderá ser desfeita.": "Questa azione non può essere annullata.",
    "company.A companhia foi removida com sucesso!": "L'azienda è stata rimossa con successo!",
    "company.Não foi possível remover a companhia": "Non è stato possibile rimuovere l'azienda",
    "company.Quant. de fornos": "Quantità di forni",
    "company.Fornos conectados": "Forni connessi",
    "company.Fornos não conectados": "Forni non connessi",
    "company.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "NON CI SONO ANCORA ATTREZZATURE REGISTRATE :(",
    "company.description.AINDA NÃO HÁ EQUIPAMENTOS CADASTRADOS :(": "Fai clic sul pulsante nell'angolo in alto a destra e aggiungi attrezzature.",
    "company.Procurar número de série": "Cerca numero di serie",
    "company.excluir equipamento": "elimina attrezzatura",
    "company.Você deseja excluir o equipamento selecionado definitivamente?": "Desideri eliminare definitivamente l'attrezzatura selezionata?",
    "company.Número de série editado com sucesso!": "Numero di serie modificato con successo!",
    "company.Não foi possível editar o número de série. Tente novamente mais tarde": "Non è stato possibile modificare il numero di serie. Riprova più tardi",
    "company.Informe o número de série": "Inserisci il numero di serie",
    "company.Preencha um número de série": "Compila un numero di serie",
    "company.EDITAR EQUIPAMENTO": "MODIFICA ATTREZZATURA",
    "company.Modelo": "Modello",
    "company.Cadastro": "Registrazione",
    "company.Conectado": "Connesso",
    "company.SELECIONE EQUIPAMENTOS PARA EXCLUIR": "SELEZIONA LE ATTREZZATURE DA ELIMINARE",
    "company.O equipamento foi removida com sucesso!": "L'attrezzatura è stata rimossa con successo!",
    "company.Não foi possível remover o equipamento": "Non è stato possibile rimuovere l'attrezzatura",
    "company.Caracteres especiais não são permitidos, exceto o ponto e vírgula (';')": "I caratteri speciali non sono consentiti, ad eccezione del punto e virgola (';')",
    "company.Preencha o número de série sem caracteres especiais": "Inserisci il numero di serie senza caratteri speciali",
    "company.Um ou mais números de série já estão provisionados para outra companhia": "Uno o più numeri di serie sono già assegnati a un'altra azienda.",
    "company.Um ou mais números de série já estão conectados na conta de outra companhia": "Uno o più numeri di serie sono già collegati all'account di un'altra azienda.",
    
    // Error
    "error.Ocorreu um erro ao carregar esta seção": "Si è verificato un errore durante il caricamento di questa sezione",
    "error.Tentar novamente": "Riprova",
    
    //DASHBOARDS
    "dashboard.fornos vinculados" : "FORNI COLLEGATI",
    "dashboard.ativos" : "Attivi",
    "dashboard.inativos" : "Inattivi",
    "dashboard.sem status" : "Senza stato",
    "dashboard.fornos atualizados" : "FORNI AGGIORNATI",
    "dashboard.com a versão do software mais recente" : "Con la versione software più recente",
    "dashboard.chamados" : "TICKET",
    "dashboard.veja mais no app cliente" : "Scopri di più nell'APP Cliente",
    "dashboard.limpeza diária" : "PULIZIA GIORNALIERA",
    "dashboard.dos fornos estão em dia" : "dei forni è in regola",
    "dashboard.top 3" : "Top 3",
    "dashboard.média de execuções de receitas por hora" : "Media delle esecuzioni delle ricette per ora",
    "dashboard.avisos" : "AVVISI",
    "dashboard.sem avisos por aqui" : "NESSUN AVVISO",
    "dashboard.ver mais" : "Vedi altro",
    "dashboard.abertos pela plataforma IOK" : "Aperti dalla piattaforma IOK",
    "dashboard.equipamentos" : "Attrezzature",
    "dashboard.receitas" : "Ricette",
    "dashboard.executada" : "eseguita",
    "dashboard.vezes" : "volte",
    "dashboard.forno" : "Forno",
    "dashboard.média por hora" : "Media per ora",
    "dashboard.editar" : "modifica",
    "dashboard.endereço:" : "Indirizzo:",
    "dashboard.cep:" : "CAP:",
    "dashboard.estatísticas" : "Statistiche",
    "dashboard.uso de equipamento" : "Utilizzo dell'attrezzatura",
    "dashboard.pico de uso" : "Picco di utilizzo",
    "dashboard.receitas mais executadas por equipamento" : "Ricette più eseguite per attrezzatura",
    "dashboard.recolher" : "riduci",
    "dashboard.TOROS TC CONECTADOS:" : "TOROS TC COLLEGATI:",
    "dashboard.Consumo de energia - Lastro Toro TC" : "Consumo energetico - Zavorra Toro TC",
    "dashboard.tootilp": "È la somma di tutte le ricette eseguite nel giorno corrente, divisa per il numero di ore in cui il forno è acceso.",
    "dashboard.noResults": "Nessun risultato trovato :(",
    "dashboard.Preaquecimento": "Preriscaldamento",
    "dashboard.Esfriamento": "Raffreddamento",
    "dashboard.Execução de receitas": "Esecuzione ricette",
    "dashboard.Execução de receitas TSi": "Esecuzione ricette TSi",
    "dashboard.Modo manual": "Modalità manuale",
    "dashboard.Limpeza": "Pulizia",
    "dashboard.Porta": "Porta",
    "dashboard.Erros e alertas": "Errori e avvisi",
    "dashboard.Parâmetros": "Parametri",
    "dashboard.SEM DADOS POR AQUI" : "NESSUN DATO DISPONIBILE",
    "dashboard.AINDA SEM GRÁFICOS POR AQUI" : "ANCORA NESSUN GRAFICO DISPONIBILE",
    "dashboard.description.AINDA SEM GRÁFICOS POR AQUI" : "Seleziona gli elementi dall'elenco a lato per generare grafici oppure fai clic sulla riga per visualizzare maggiori dettagli.",
    
    //INFORMAÇÕES IOK
    "iokInformation.search.placeholder" : "Cerca articolo",
    "iokInformation.article.openInHelpCenter": "Visualizza l’articolo nel Centro assistenza",
    "iokInformation.aboutPlatform.platformFeatures.title": "La piattaforma e le sue funzionalità",
    "iokInformation.aboutPlatform.platformFeatures.linkLabel": "Scarica la presentazione completa",
    "iokInformation.aboutPlatform.manual.title": "Manuale di istruzioni",
    "iokInformation.aboutPlatform.manual.linkLabel": "Scarica il manuale",
    "iokInformation.aboutPlatform.privacy.title": "Informativa sulla privacy",
    "iokInformation.aboutPlatform.privacy.linkLabel": "Scarica l'informativa",
    "iokInformation.aboutPlatform.api.title": "API Esterna",
    "iokInformation.aboutPlatform.api.linkLabel": "Scarica il documento",
    
    //Telemetry TSI
    "telemetry.EQUIPMENT_TURN_ON": "Apparecchiatura accesa",
    "telemetry.SENSORS_VALUES": "Valori dei sensori",
    "telemetry.ERROR_DETECTED": "Errore rilevato",
    "telemetry.TIME_ADDED": "Tempo aggiunto",
    "telemetry.GN_ADDED": "GN aggiunta",
    "telemetry.GN_RELEASED": "GN avviata",
    "telemetry.GN_FINISHED": "GN completata",
    
    "telemetry.HEAVY_CLEANING_CANCELED": "Pulizia intensiva annullata",
    "telemetry.CLEANING_CANCELED": "Pulizia annullata",
    "telemetry.CLEANING_RESTARTED": "Pulizia riavviata",
    "telemetry.CLEANING_VAPORIZATION_STEP": "Fase di vaporizzazione della pulizia",
    "telemetry.CLEANING_SUPPLY_STEP": "Fase di riempimento della pulizia",
    "telemetry.CLEANING_CIRCULATION_STEP": "Fase di circolazione della pulizia",
    "telemetry.CLEANING_DEPLETION_STEP": "Fase di scarico della pulizia",
    "telemetry.CLEANING_RISING_STEP": "Fase di risciacquo della pulizia",
    "telemetry.CLEANING_STARTED": "Pulizia avviata",
    "telemetry.CLEANING_FINISHED": "Pulizia completata",
    "telemetry.RECOMMENDED_CLEANING": "Pulizia consigliata",
    "telemetry.VALID_PASSWORD_CLEANING": "Password valida per la pulizia",
    "telemetry.INVALID_PASSWORD_CLEANING": "Password non valida per la pulizia",
    
    "telemetry.RECIPE_STARTED": "Ricetta avviata",
    "telemetry.RECIPE_FINISHED": "Ricetta completata",
    "telemetry.RECIPE_CANCELED": "Ricetta annullata",
    "telemetry.RECIPE_STEP_CHANGED": "Fase della ricetta modificata",
    "telemetry.RECIPE_PAUSED": "Ricetta in pausa",
    "telemetry.RECIPE_RESUMED": "Ricetta ripresa",
    "telemetry.DROP_ENERGY_SUPPLY": "Ripresa dopo un'interruzione di corrente",
    "telemetry.RESUME_RECIPE_CANCELED": "Ripresa della ricetta annullata",
    
    "telemetry.PRE_HEAT_STARTED": "Preriscaldamento avviato",
    "telemetry.PRE_HEAT_FINISHED": "Preriscaldamento completato",
    "telemetry.OPERATION_CONTINUE_STARTED": "Ripresa dell'operazione avviata",
    "telemetry.OPERATION_CONTINUE_FINISHED": "Ripresa dell'operazione completata",
    "telemetry.HOLD_TEMPERATURE_STARTED": "Mantenimento della temperatura avviato",
    "telemetry.HOLD_TEMPERATURE_FINISHED": "Mantenimento della temperatura completato",
    "telemetry.COOL_DOWN_STARTED": "Raffreddamento avviato",
    "telemetry.COOL_DOWN_FINISHED": "Raffreddamento completato",
    "telemetry.NOCTURNAL_COOKING_STARTED": "Cottura notturna avviata",
    "telemetry.NOCTURNAL_COOKING_FINISHED": "Cottura notturna completata",
    "telemetry.SEALING_STARTED": "Sigillatura avviata",
    "telemetry.SEALING_FINISHED": "Sigillatura completata",
    "telemetry.TURBO_GRILL_STARTED": "Turbo Grill avviato",
    "telemetry.TURBO_GRILL_FINISHED": "Turbo Grill completato",
    "telemetry.TURBO_GRILL_ACTIVATED": "Turbo Grill attivato",
    "telemetry.TURBO_GRILL_DISABLED": "Turbo Grill disattivato",
    
    "telemetry.MOISTURE_CHANGED": "Umidità modificata",
    "telemetry.TURBINE_CHANGED": "Valore della turbina modificato",
    "telemetry.SET_POINT_CHANGED": "Temperatura della camera modificata",
    "telemetry.STEAM_CHANGED": "Vapore modificato",
    "telemetry.PROBE_CHANGED": "Temperatura della sonda modificata",
    "telemetry.TIME_CHANGED": "Tempo modificato",
    "telemetry.DOOR_OPENED": "Porta aperta",
    "telemetry.DOOR_CLOSED": "Porta chiusa",
    
    "telemetry.PROBE_CONTROL_SELECTED": "Controllo tramite sonda selezionato",
    "telemetry.TIME_CONTROL_SELECTED": "Controllo tramite tempo selezionato",
    "telemetry.MANUAL_STEAM_INJECTED": "Iniezione manuale di vapore",
    "telemetry.AUTOMATIC_STEAM_INJECTED": "Iniezione automatica di vapore",
    
    "telemetry.DATABASE_CREATED": "Creazione del database",
    "telemetry.EXIT_FUNCTION": "Funzione terminata",
    "telemetry.CONSUMPTION": "Consumo",
    "telemetry.STANDBY": "Standby",
    
    "telemetry.ANALYTICS_ERROR_BAD_REQUEST": "Errore analytics: Richiesta non valida",
    "telemetry.ANALYTICS_ERROR_FORBIDDEN": "Errore analytics: Accesso negato",
    "telemetry.ANALYTICS_ERROR_SERVER": "Errore analytics: Errore del server",
    "telemetry.ANALYTICS_ERROR_UNEXPECTED": "Errore analytics: Errore imprevisto",
    "telemetry.ANALYTICS_SUCCESS": "Analytics eseguita con successo",
    
    "telemetry.STEP": "Passaggio",
    "telemetry.STEAM": "Vapore",
    "telemetry.PROBE": "Sonda",
    "telemetry.TURBINE": "Turbina",
    "telemetry.OCCURRENCES": "occorrenza/e",
    "telemetry.FUNC_USER_RECIPE": "Ricetta utente",
    "telemetry.FUNC_TSI_RECIPE": "Ricetta TSi",
    "telemetry.FUNC_DELTA_T": "Delta T",
    "telemetry.FUNC_STEAM": "Vapore",
    "telemetry.FUNC_COMBINED_STEAM": "Vapore combinato",
    "telemetry.FUNC_HOT_AIR": "Aria calda",
    "telemetry.FUNC_NOCTURNAL_COOKING": "Cottura notturna",
    "telemetry.FUNC_REGENERATE": "Rigenerazione",
    "telemetry.FUNC_MULTIPLE_COOKING": "Cottura multipla",
    
    "haccp.filterBy": "Filtra per",
    "haccp.export.generating": "Il foglio HACCP è in fase di generazione e verrà scaricato automaticamente a breve.",
    "haccp.voltage": "Tensione",
    "haccp.voltageReading": "Lettura della tensione",
    "haccp.voltageOscillation": "Oscillazione della tensione nel giorno",
    "haccp.status.normal": "Normale",
    "haccp.status.attention": "Attenzione",
    "haccp.status.critical": "Critico",
    "haccp.dateTime": "Data/Ora",
    "haccp.errorDetected": "Errore/Allarme rilevato",
    "haccp.detected": "rilevato",
    "haccp.errorTypeLabel": "Tipo di errore/allarme",
    "haccp.severityLabel": "Gravità",
    "haccp.severity.error": "Errore",
    "haccp.severity.alert": "Allarme",
    "haccp.error.canNetwork": "Errore rete CAN",
    "haccp.error.chamberSensor": "Errore sensore camera",
    "haccp.error.steamSensor": "Errore sensore vapore",
    "haccp.error.probeSensor": "Errore sonda",
    "haccp.error.noWater": "Errore mancanza acqua",
    "haccp.error.panelTemp": "Errore temp. pannello",
    "haccp.error.motor": "Errore motore",
    "haccp.error.motorComm": "Errore comunicazione motore",
    "haccp.error.hygieneIncomplete": "Errore igienizzazione incompleta",
    "haccp.error.familyModel": "Errore famiglia/modello",
    "haccp.error.boardTemp": "Errore temp. scheda",
    "haccp.error.energyModule": "Errore modulo energia",
    "haccp.error.i2c": "Errore I2C",
    "haccp.error.gas": "Errore gas",
    "haccp.loading": "Caricamento...",
    "haccp.quantity": "Quantità",
    "haccp.executions": "Esecuzioni",
    "haccp.manual.mode": "Modalità",
    "haccp.manual.tempC": "Temp (°C)",
    "haccp.manual.timeMin": "Tempo (min)",
    "haccp.manual.probeC": "Sonda (°C)",
    "haccp.manual.steamPct": "Vapore %",
    "haccp.cleaning.label": "Pulizia",
    "haccp.cleaning.recommendedLabel": "Pulizia consigliata",
    "haccp.cleaning.status.completed": "Completata",
    "haccp.cleaning.status.restarted": "Riavviata",
    "haccp.cleaning.status.interrupted": "Interrotta",
    "haccp.status.label": "Stato",
    "haccp.error": "Errore",
    "haccp.consumption.water": "Consumo acqua",
    "haccp.consumption.energy": "Consumo energia",
    "haccp.short.temp": "Temp",
    "haccp.short.time": "Tempo",
    "haccp.day": "Giorno",
    "haccp.recipeExecutions": "N. esecuzioni",
    "STEAM": "Vapore",
    "COMBINED_STEAM": "Vapore combinato",
    "PROBE": "Sonda",
    "TURBINE": "Turbina",
    "HOT_AIR": "Aria calda",
    "NOCTURNAL_COOKING": "Cottura notturna",
    "REGENERATE": "Rigenerazione",
    "MULTIPLE_COOKING": "Cottura multipla",
    "DELTA_T": "Delta T",
    
    //CSAT
    "csat.AVALIE SUA EXPERIÊNCIA": "VALUTA LA TUA ESPERIENZA",
    "csat.Como você avalia sua experiência com": "Come valuti la tua esperienza con",
    "csat.Muito insatisfeito": "Molto insoddisfatto",
    "csat.Insatisfeito": "Insoddisfatto",
    "csat.Neutro": "Neutrale",
    "csat.Satisfeito": "Soddisfatto",
    "csat.Muito satisfeito": "Molto soddisfatto",
    "csat.Utilize o espaço abaixo para deixar suas sugestões:": "Utilizza lo spazio sottostante per lasciare i tuoi suggerimenti:",
    "csat.Digite aqui": "Scrivi qui",
    "csat.Obrigado por responder à nossa pesquisa!": "Grazie per aver risposto al nostro sondaggio!",
    "csat.Selecione uma nota para continuar": "Seleziona un punteggio per continuare",
    "csat.Enviar": "Invia",
    "csat.a criação de receitas": "la creazione di ricette",
    "csat.o cadastro de equipamentos": "la registrazione delle attrezzature",
    "csat.o cadastro de usuários": "la registrazione degli utenti",
    "csat.a criação de menus": "la creazione di menu",
    "csat.a deleção de receitas": "l'eliminazione delle ricette",
    "csat.a reordenação de receitas": "il riordino delle ricette",
    "csat.o envio de software": "l'invio del software",
    "csat.o envio de menus": "l'invio dei menu",
    "csat.o uso de receitas do Cookbook": "l'utilizzo delle ricette del Cookbook"
  },
};

export default it;


